<template>
  <div class="chart-wrap">
    <div class="big-chart right" :class="{show: show}">
      <div class="big-chart-header">
      
      </div>
      <div class="big-chart-main">
        <div class="close" @click="$emit('close')">
          关闭
        </div>
        <div class="big-chart-main-view">
          <h3 class="title">
            <img src="./../../../assets/image/simulation/txt1.png" alt="">
            关于Shopee购物平台的茶产品（正山小种、大红袍、茉莉花茶）的数据</h3>
          <div class="table-wrap">
            <div style="display: flex;justify-content: flex-end;">
              <el-pagination
                  :current-page="1"
                  @current-change="changePage"
                  :page-count="6"
                  layout="prev, pager, next"
                  :total="tableData.length">
              </el-pagination>
            </div>
            <el-table
                :data="tableFilter"
                border
                style="width: 100%">
              <el-table-column
                  prop="tea"
                  label="茶产品"
                  width="100">
              </el-table-column>
              <el-table-column
                  prop="sku"
                  label="SKU"
                  width="130">
              </el-table-column>
              <el-table-column
                  label="图片"
                  width="100">
                <template slot-scope="scope">
                  <img :src="scope.row.image" alt="" width="60">
                </template>
              </el-table-column>
              <el-table-column
                  prop="title"
                  label="标题">
              </el-table-column>
              <el-table-column
                  prop="salePrice"
                  label="价格">
              </el-table-column>
              <el-table-column
                  prop="sold"
                  label="销量">
              </el-table-column>
            </el-table>
          </div>
          <div class="echart-wrap">
            <el-timeline>
              <el-timeline-item color="red" size="large" timestamp="步骤一：数据汇总" placement="top">
                <div style="display: flex;">
                  <el-card style="width: 320px;margin-right: 10px" v-for="(card,cardindex) in initData.summaryAttr"
                           :key="cardindex">
                    <div slot="header" class="clearfix">
                      <span>茶产品数据汇总</span>
                      <el-button style="float: right; padding: 3px 0" type="text" @click="generateTable(card)">生成汇总表格
                      </el-button>
                    </div>
                    <div
                        style="padding: 14px;display: flex;flex-direction: column;border-radius: 6px;margin-bottom: 10px">
                      <div style="margin-bottom: 10px">茶产品名称</div>
                      <el-input style="margin-bottom: 10px" v-model="card.name" placeholder="请输入需要汇总的茶产品名称"></el-input>
                      <div style="margin-bottom: 10px">茶产品SKU</div>
                      <el-input style="margin-bottom: 10px" v-model="card.sku" placeholder="请输入需要汇总的茶产品SKU"></el-input>
                      <div style="margin-bottom: 10px">需要汇总销量的价格区间</div>
                      <el-input type="textarea" :rows="3" style="margin-bottom: 10px" v-model="card.range"
                                placeholder="请输入茶产品价格区间。例如：0-10,10-15,15-25,区间数值用逗号隔开"></el-input>
                    </div>
                  </el-card>
                </div>
                <div class="generate-table-wrap">
                  <div style="box-shadow: 0 0 10px #9e9e9e;margin: 10px 0;border-radius: 6px;overflow: hidden"
                       v-for="(item,index) in initData.summaryAttr" :key="index">
                    <div class="g-t-w-view" style="display: flex">
                      <div class="g-t-w-v-row" v-for="(val,vkey,vindex) in item.items?item.items[0] : []"
                           :key="vindex ">
                        <div class="label">
                          {{vkey}}
                        </div>
                        <div class="value">
                          {{val}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </el-timeline-item>
              <el-timeline-item color="red" size="large" timestamp="步骤二：设定图表X轴和Y轴的数据类型" placement="top">
                <el-card>
                  <div style="width: 200px">
                    <h4 style="margin-bottom: 10px">X轴</h4>
                    <el-input v-model="initData.Barform.inputX" placeholder="请输入X轴单位"></el-input>
                  </div>
                  <div style="width: 200px">
                    <h4 style="margin-bottom: 10px">Y轴</h4>
                    <el-input v-model="initData.Barform.inputY" placeholder="请输入Y轴单位"></el-input>
                  </div>
                </el-card>
              </el-timeline-item>
              <el-timeline-item color="red" size="large" timestamp="步骤三：添加数据点" placement="top">
                <div style="display: flex">
                  <el-card style="width: 360px;margin-right: 10px" v-for="(item,index) in initData.barData"
                           :key="index">
                    <div slot="header" class="clearfix">
                      <span>图表数据集</span>
                    </div>
                    <div style="margin-bottom: 10px">
                      <el-input style="width: 300px;margin-right: 6px" v-model="item.name"
                                placeholder="自定义图表名称"></el-input>
                    </div>
                    <div style="display: flex;flex-direction:column;" v-for="(itemm,indexx) in item.data" :key="indexx">
                      <div style="display: flex;margin-bottom: 10px">
                        <el-input style="width: 150px;margin-right: 6px" v-model="itemm.x"
                                  placeholder="请输入X轴数据"></el-input>
                        <el-input style="width: 150px;margin-right: 6px" v-model="itemm.y"
                                  placeholder="请输入Y轴数据"></el-input>
                        <el-button type="danger" icon="el-icon-delete" circle
                                   @click="item.data.splice(indexx,1)"></el-button>
                      </div>
                    </div>
                    <el-button type="danger" icon="el-icon-plus" @click="item.data.push({x:'',y:''})"></el-button>
                  </el-card>
                </div>
              </el-timeline-item>
              <el-timeline-item color="red" size="large" timestamp="步骤四：预览图表" placement="top">
                <div v-for="(item,index) in initData.barData" :key="index" style="margin-bottom: 10px">
                  <el-card>
                    <Bar
                        type="line"
                        :x-data="item.data"
                        :y-data="item.data"
                        :y-label="initData.Barform.inputY"
                        :x-label="initData.Barform.inputX"
                        :name="item.name"
                    >
                    </Bar>
                  </el-card>
                </div>
              </el-timeline-item>
              <el-timeline-item color="red" size="large" timestamp="步骤五：分析任务" placement="top">
                <el-card>
                  <div slot="header" class="clearfix">
                    <span>请根据图表，分析总结shopee平台，茶产品的销量情况，通过单个商品最高价格区间、最低价格区间、销量集中价格区间等维度分析总结。
                    </span>
                  </div>
                  <div>
                    <el-input type="textarea" :rows="6" style="margin-bottom: 10px" v-model="initData.zongjie"
                              placeholder=""></el-input>
                  </div>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div>
          <div style="display: flex;justify-content: flex-end">
            <el-button type="danger" @click="finish">提交</el-button>
          </div>
        </div>
      </div>
      <div class="people-wrap">
        <img class="person-image" src="./../../../assets/image/simulation/people-img-2.png" alt="">
        <div class="people-talk" v-if="talk.index===0">
          <p>数据虽然已经整理成表格，但表格中数据较多，并不适合直接作为分析数据来用，这时候需要将表格中的数据二次筛选</p>
          <div class="next-btn">
            <i class="el-icon-caret-bottom" @click="talk.index+=1"></i>
          </div>
        </div>
        <div class="people-talk" v-if="talk.index===1">
          <p>第一步，我们需要单个商品的销量数据，在左侧的步骤一的数据汇总上，我们可以先添加需要汇总的商品名称和商品SKU，并填写需要汇总的价格区间，系统会自动查询数据库，生成汇总表格</p>
          <div class="next-btn">
            <i class="el-icon-caret-bottom" @click="talk.index+=1"></i>
          </div>
        </div>
        <div class="people-talk" v-if="talk.index===2">
          <p>第二步，根据汇总表格和数据库列表，我们可以确定2个元素（产品价格区间和产品价格区间对应的销量）各自的单位，我们选用折线图，请在左侧步骤二中确定x轴和y轴的单位</p>
          <div class="next-btn">
            <i class="el-icon-caret-bottom" @click="talk.index+=1"></i>
          </div>
        </div>
        <div class="people-talk" v-if="talk.index===3">
          <p>
            第三步，确定了x轴和y轴的单位之后，我们需要根据汇总表格绘制折线图，请在左侧步骤三添加数据点，比如：商品0-10元区间，商品的销量为1000，即x轴数据为【0-10元】，y轴数据为【1000】，系统会自动生成对应的可视化折线图</p>
          <div class="next-btn">
            <i class="el-icon-caret-bottom" @click="talk.index+=1"></i>
          </div>
        </div>
        <div class="people-talk" v-if="talk.index===4">
          <p>第四步，观察折线图，我们可以调整步骤一的【需要汇总销量的价格区间】数据，尽可能的筛选出销量最好的产品最优的价格区间</p>
          <div class="next-btn">
            <i class="el-icon-caret-bottom" @click="talk.index+=1"></i>
          </div>
        </div>
        <div class="people-talk" v-if="talk.index===5">
          <p>第五步，根据您绘制的图标，通过单个商品最高价格区间、最低价格区间、销量集中价格区间等维度分析总结shopee平台，茶产品的销量情况</p>
          <div class="next-btn">
            <i class="el-icon-caret-bottom" @click="talk.index = 0"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Bar from './bar'
  
  export default {
    name: "chartComponent3",
    props: ['show'],
    components: {
      Bar
    },
    data() {
      return {
        initData: {
          title: '消费力',
          resolve: false,
          zongjie: '',
          summaryAttr: {
            card1: {
              name: '茉莉花',
              sku: 'TEA514521548',
              range: '0-5,5-10,10-20,30-40,40-50,60-70,70-80,80-90,100-200',
              items: []
            },
            card2: {
              name: '正山小种',
              sku: 'TEA474528754',
              range: '0-5,5-10,10-20,30-40,40-50,60-70,70-80,80-90,100-200',
              items: []
            },
            card3: {
              name: '大红袍',
              sku: 'TEA784584123',
              range: '0-5,5-10,10-20,30-40,40-50,60-70,70-80,80-90,100-200',
              items: []
            }
          },
          Barform: {
            inputX: '',
            inputY: ''
          },
          barData: [
            {
              data: [{x: "", y: ""}],
              name: "",
              xLabel: '',
              yLabel: ''
            },
            {
              data: [{x: "", y: ""}],
              name: "",
              xLabel: '',
              yLabel: ''
            },
            {
              data: [{x: "", y: ""}],
              name: "",
              xLabel: '',
              yLabel: ''
            }
          ]
        },
        
        talk: {
          index: 0,
          talkItems: [
            "数据虽然已经整理成表格，但表格中数据较多，并不适合直接作为分析数据来用，这时候需要将表格中的数据进行可视化",
            "第一步"
          ]
        },
        tableData: [
          {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/328c46669a26bf41c21aac0bdf7a7c99_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM96.24 - RM113.63",
            "price": "",
            "product_id": 174,
            "place": "Mainland China",
            "title": "Is The Small Tea Gift Gold Jun Eyebrow Black 18 Cans 250g正山小种茶叶 高档礼盒装送礼 金骏眉红茶大红袍浓香型18罐共250gbycgrrfsa.my10.19",
            "url": "https://my.xiapibuy.com//Is-The-Small-Tea-Gift-Gold-Jun-Eyebrow-Black-18-Cans-250g正山小种茶叶-高档礼盒装送礼-金骏眉红茶大红袍浓香型18罐共250gbycgrrfsa.my10.19-i.415314684.13831363417?sp_atk=78d46b79-cce2-4006-a31d-c222e2665dba",
            "labels": [],
            "sku": "TEA474528754"
          },{
            "country": "马来西亚",
            "tea": "竹筒",
            "image": "https://cf.shopee.com.my/file/ea8cc28eb3c607e0936c75962d51d6c5",
            "sold": "328",
            "create_time": 1637748869000,
            "salePrice": "RM16.99 - RM27.99",
            "price": "",
            "product_id": 174,
            "place": "Mainland China",
            "title": "天然竹杯Natural bamboo cup竹制品竹筒饭天然竹筒商用楠竹粽子蒸筒家用蒸饭竹管子 笔筒复古",
            "url": "https://shopee.com.my/%E5%A4%A9%E7%84%B6%E7%AB%B9%E6%9D%AFNatural-bamboo-cup%E7%AB%B9%E5%88%B6%E5%93%81%E7%AB%B9%E7%AD%92%E9%A5%AD%E5%A4%A9%E7%84%B6%E7%AB%B9%E7%AD%92%E5%95%86%E7%94%A8%E6%A5%A0%E7%AB%B9%E7%B2%BD%E5%AD%90%E8%92%B8%E7%AD%92%E5%AE%B6%E7%94%A8%E8%92%B8%E9%A5%AD%E7%AB%B9%E7%AE%A1%E5%AD%90-%E7%AC%94%E7%AD%92%E5%A4%8D%E5%8F%A4-i.473463105.11828831537?sp_atk=78507e1b-9ea9-4394-b98b-afe681ab4fa8&xptdk=78507e1b-9ea9-4394-b98b-afe681ab4fa8",
            "labels": [],
            "sku": "MT1587451201"
          },{
            "country": "泰国",
            "tea": "竹签",
            "image": "https://cf.shopee.com.my/file/c9f96437928e2e706c595005762a8132",
            "sold": "157",
            "create_time": 1637748869000,
            "salePrice": "RM0.99 - RM1.99",
            "price": "",
            "product_id": 174,
            "place": "Mainland China",
            "title": "3.0mm X 30cm Bamboo Stick/ Lidi Bambu 包花用具竹签 30cm x 3.0mm",
            "url": "https://shopee.com.my/3.0mm-X-30cm-Bamboo-Stick-Lidi-Bambu-%E5%8C%85%E8%8A%B1%E7%94%A8%E5%85%B7%E7%AB%B9%E7%AD%BE-30cm-x-3.0mm-i.12856589.5857939768?sp_atk=f860b80f-4466-490a-adb3-7aa1cfa7c261&xptdk=f860b80f-4466-490a-adb3-7aa1cfa7c261",
            "labels": [],
            "sku": "MT1587451201"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/c573b49ae824ec969b6dc056543d53f0_tn",
            "sold": "15.8k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.48 - RM0.85",
            "price": "",
            "product_id": 8,
            "place": "Kuala Lumpur",
            "title": "????现货????优惠价 散装中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 金丝皇菊 菊花茶 茶叶 Chinese Tea Da Hong Pao Tie Guan Yin Pu erShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//????现货????优惠价-散装中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-金丝皇菊-菊花茶-茶叶-Chinese-Tea-Da-Hong-Pao-Tie-Guan-Yin-Pu-er-i.128031579.11920308453?sp_atk=653d8cad-2a7e-403c-8d1d-de6b234286ef",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/f1da5b1d2762f9a5bfc1b6df159f7907_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM11.15 - RM47.23",
            "price": "",
            "product_id": 143,
            "place": "Melaka",
            "title": "Lapsang Souchong authentic black tea 202正山小种正宗红茶2021新茶浓香型茶叶暖胃茶叶非特级做奶茶lrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Lapsang-Souchong-authentic-black-tea-202正山小种正宗红茶2021新茶浓香型茶叶暖胃茶叶非特级做奶茶lrw3f3ycn7-i.431042679.13003973806?sp_atk=43420f55-ec06-4524-b3b4-32da82685b43",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/3ef9bfac59254673c55d189839e18f83_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM28.80",
            "price": "RM49.00",
            "product_id": 76,
            "place": "Selangor",
            "title": "Fu Jian WuYi  Mountain DaHongPao Tea（a box 30pcs）武夷山岩茶大红袍RM1 offShopMalaysia",
            "url": "https://my.xiapibuy.com//Fu-Jian-WuYi-Mountain-DaHongPao-Tea（a-box-30pcs）武夷山岩茶大红袍-i.155958055.12647869425?sp_atk=69c771e5-b584-41e8-9813-7c54b8c4d63d",
            "labels": [],
            "sku": "TEA784584123"
          },{
            "country": "马来西亚",
            "tea": "竹制可重复使用木汤匙",
            "image": "https://cf.shopee.com.my/file/my-50009109-6b23c8f223cf4926180abf68d04ffa3b",
            "sold": "871",
            "create_time": 1637748869000,
            "salePrice": "RM1.29",
            "price": "RM1.29",
            "product_id": 76,
            "place": "Selangor",
            "title": "𝗛𝗢𝗡𝗘𝗦𝗧𝗘𝗔.𝟮𝟭 [Buy 10 Free 1] Reusable Wooden Spoon Teaspoon Buluh Sudu Kayu 竹制可重复使用木汤匙 日式 Dessert Coffee Japanese Style",
            "url": "https://shopee.com.my/%F0%9D%97%9B%F0%9D%97%A2%F0%9D%97%A1%F0%9D%97%98%F0%9D%97%A6%F0%9D%97%A7%F0%9D%97%98%F0%9D%97%94.%F0%9D%9F%AE%F0%9D%9F%AD-Buy-10-Free-1-Reusable-Wooden-Spoon-Teaspoon-Buluh-Sudu-Kayu-%E7%AB%B9%E5%88%B6%E5%8F%AF%E9%87%8D%E5%A4%8D%E4%BD%BF%E7%94%A8%E6%9C%A8%E6%B1%A4%E5%8C%99-%E6%97%A5%E5%BC%8F-Dessert-Coffee-Japanese-Style-i.525077742.10750434137?sp_atk=28113549-65a2-4227-a547-63778e914e7c&xptdk=28113549-65a2-4227-a547-63778e914e7c",
            "labels": [],
            "sku": "UOA754884123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/11bd3f8dc4ba315ae2613c3edbae2102_tn",
            "sold": "327 sold",
            "create_time": 1637748869000,
            "salePrice": "RM9.90",
            "price": "RM13.00",
            "product_id": 112,
            "place": "Selangor",
            "title": "茶叶 2021 New Chinese Tea 铁观音 大红袍 金骏眉 高山绿茶 碧螺春 普洱熟茶 龙井 Tie Guan Yin Da Hong Pao Puer teh Jasmine teaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茶叶-2021-New-Chinese-Tea-铁观音-大红袍-金骏眉-高山绿茶-碧螺春-普洱熟茶-龙井-Tie-Guan-Yin-Da-Hong-Pao-Puer-teh-Jasmine-tea-i.10462357.6974073771?sp_atk=b48e8e5d-4f6c-468c-8e99-a725e35c59c4",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/a69fe7378dba45c1638db534478e6a73_tn",
            "sold": "7 sold",
            "create_time": 1637748869000,
            "salePrice": "RM4.00 - RM18.85",
            "price": "",
            "product_id": 167,
            "place": "Mainland China",
            "title": "Tea caddy  现货速发  小罐散茶罐  空铝罐  白毫银针  正山小种绿茶  白茶便携  马口铁茶  叶罐包装COD",
            "url": "https://my.xiapibuy.com//Tea-caddy-现货速发-小罐散茶罐-空铝罐-白毫银针-正山小种绿茶-白茶便携-马口铁茶-叶罐包装-i.433757760.4990430435?sp_atk=6911171c-143e-4634-9721-ac79a7904fd1",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/8fdd21a0af3044e9e54fc2b8cc47e831_tn",
            "sold": "65 sold",
            "create_time": 1637748869000,
            "salePrice": "RM13.50",
            "price": "",
            "product_id": 59,
            "place": "Perak",
            "title": "菊花决明子茶 Chrysanthemum Cassia Seed Tea (30s) 熬夜恢复茶 养肝茶Local Seller",
            "url": "https://my.xiapibuy.com//菊花决明子茶-Chrysanthemum-Cassia-Seed-Tea-(30s)-熬夜恢复茶-养肝茶-i.277548324.3039552521?sp_atk=2cf589f4-33bb-4ce7-bcea-938147b9858e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/44b8a3c3b639d0d6d22b2078f92653c7_tn",
            "sold": "5 sold",
            "create_time": 1637748869000,
            "salePrice": "RM4.99 - RM14.99",
            "price": "",
            "product_id": 51,
            "place": "Kuala Lumpur",
            "title": "Jasmine Flower Tea 茉莉花茶Jasmine Flower 茉莉花 Bunga Melati 30g~100gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Jasmine-Flower-Tea-茉莉花茶Jasmine-Flower-茉莉花-Bunga-Melati-30g~100g-i.145759214.6982277726?sp_atk=2cc483eb-99ca-4b20-b5e0-40aefe135252",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/7cb997935f7d443626569a026737f982_tn",
            "sold": "32 sold",
            "create_time": 1637748869000,
            "salePrice": "RM5.90",
            "price": "",
            "product_id": 27,
            "place": "Perak",
            "title": "{RM 5.9 / 50g} Jasmine tea  flower tea 浓香型茉莉花茶浓香小白豪 花茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//-RM-5.9-50g-Jasmine-tea-flower-tea-浓香型茉莉花茶浓香小白豪-花茶-i.175903848.3537059934?sp_atk=ea12bb88-f1bc-4b0e-a851-bf3f1faece1f",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/f8e70c66fa49bfe37bcfe3db196117ca_tn",
            "sold": "9 sold",
            "create_time": 1637748869000,
            "salePrice": "RM8.99",
            "price": "RM12.90",
            "product_id": 44,
            "place": "Selangor",
            "title": "Matcharo Jasmine Green Tea (10 tea bag) 花茶- 茉莉绿茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Matcharo-Jasmine-Green-Tea-(10-tea-bag)-花茶-茉莉绿茶-i.53852994.4484044181?sp_atk=ca44ade1-7063-4b23-9a92-dcaa31fd6a4b",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/4fdf2ada49151286a0300f84c2f7e310_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM22.00 - RM42.00",
            "price": "",
            "product_id": 165,
            "place": "Mainland China",
            "title": "New tea authentic Dahongpao Jinjunmei Tieguanyin Zhengshan small Biluochun old w新茶 正宗大红袍金骏眉铁观音正山小种碧螺春老白茶 茶叶罐装jiumei10.my21.10.14RM2 off",
            "url": "https://my.xiapibuy.com//New-tea-authentic-Dahongpao-Jinjunmei-Tieguanyin-Zhengshan-small-Biluochun-old-w新茶-正宗大红袍金骏眉铁观音正山小种碧螺春老白茶-茶叶罐装jiumei10.my21.10.14-i.427603284.11559332819?sp_atk=a021a318-6bec-44f6-a617-36b7d93cea8c",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/d9f5f1374ad3dc79a513394c41f64570_tn",
            "sold": "47 sold",
            "create_time": 1637748869000,
            "salePrice": "RM10.50",
            "price": "RM10.90",
            "product_id": 12,
            "place": "Penang",
            "title": "Jasmine Tea Flower Tea 100g 浓香型茉莉花茶浓香小白豪 花茶RM1 offShopMalaysia",
            "url": "https://my.xiapibuy.com//Jasmine-Tea-Flower-Tea-100g-浓香型茉莉花茶浓香小白豪-花茶-i.60201032.8749449249?sp_atk=f2a9d2c8-d6ec-4d45-b0cd-0cf8235696f1",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/4bdac61f6c9dc175a7bb9c329cbaf7b0_tn",
            "sold": "18.8k sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.70",
            "price": "",
            "product_id": 53,
            "place": "Selangor",
            "title": "农夫山泉 茶兀饮料  500ml 蜜桃乌龙茶 西柚茉莉花茶 柠檬红茶 玫瑰荔枝红茶 柚子绿茶 Nongfu Spring Tea DrinksShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//农夫山泉-茶兀饮料-500ml-蜜桃乌龙茶-西柚茉莉花茶-柠檬红茶-玫瑰荔枝红茶-柚子绿茶-Nongfu-Spring-Tea-Drinks-i.84694438.9243308046?sp_atk=b62f673c-daf6-42ab-8a27-edbcf3c95096",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/b3a1dfa13bda919bb37bc081fa6441c1_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM36.00 - RM71.00",
            "price": "",
            "product_id": 140,
            "place": "Mainland China",
            "title": "[give one pot and four cups] Jin Junmei Zhengshan seed 250G / 500g tea black tea�【赠一壶四杯】金骏眉正山小种250g/500g茶叶红茶礼盒装罐装散装blxy017.my21.10.26RM5 offEconomyDelivery",
            "url": "https://my.xiapibuy.com//-give-one-pot-and-four-cups-Jin-Junmei-Zhengshan-seed-250G-500g-tea-black-tea�【赠一壶四杯】金骏眉正山小种250g-500g茶叶红茶礼盒装罐装散装blxy017.my21.10.26-i.208632003.11364313407?sp_atk=b272a682-b45f-4761-9dc7-5ea7228f7f4e",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/dc7caba94f90ce43f28ebe2bc3beb05d_tn",
            "sold": "1.7k sold",
            "create_time": 1637748869000,
            "salePrice": "RM16.79 - RM19.03",
            "price": "",
            "product_id": 100,
            "place": "Selangor",
            "title": "茶叶 铁观音 大红袍 金骏眉 碧螺春 普洱 高山绿茶 毛尖 Chinese tea Teh Cina White tea puer Pu Er Tie guan yin Teh ChinaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茶叶-铁观音-大红袍-金骏眉-碧螺春-普洱-高山绿茶-毛尖-Chinese-tea-Teh-Cina-White-tea-puer-Pu-Er-Tie-guan-yin-Teh-China-i.10462357.3874062737?sp_atk=8a32cf44-cc61-4668-883b-fbb4c9f36f3f",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/76389cb88c4fc1b951faca45f67f154a_tn",
            "sold": "223 sold",
            "create_time": 1637748869000,
            "salePrice": "RM7.50 - RM9.90",
            "price": "",
            "product_id": 29,
            "place": "Johor",
            "title": "渝达 天然养生花茶 三角茶包 脂流茶柠檬山楂荷叶茶 Herbal Rose Peach Oolong Flower Tea 薄荷绿茶 白蜜桃乌龙茶 桂花乌龙茶 茉莉薄荷茶 玫瑰红茶 茉莉绿茶 红豆薏米 菊花决明子 Black TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//渝达-天然养生花茶-三角茶包-脂流茶柠檬山楂荷叶茶-Herbal-Rose-Peach-Oolong-Flower-Tea-薄荷绿茶-白蜜桃乌龙茶-桂花乌龙茶-茉莉薄荷茶-玫瑰红茶-茉莉绿茶-红豆薏米-菊花决明子-Black-Tea-i.99094.3391347066?sp_atk=27f60e8a-814f-42df-89f3-acf614ac8c31",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/22d78d2f88bc1d61b24c6298224e5ed2_tn",
            "sold": "949 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.55",
            "price": "RM1.10",
            "product_id": 128,
            "place": "Penang",
            "title": "福建红茶正山小种茶叶 6g Fujian Black Tea Zhengshan Small TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//福建红茶正山小种茶叶-6g-Fujian-Black-Tea-Zhengshan-Small-Tea-i.60201032.3338624999?sp_atk=06a79976-2e44-496f-bdc5-f81db6cdf361",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/4442f92f640569b2e39e052323754126_tn",
            "sold": "51 sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.00",
            "price": "",
            "product_id": 18,
            "place": "Negeri Sembilan",
            "title": "香片 茉莉花茶 Jasmine Tea 10g Chinese Tea 中国茶叶(花茶)  (Scented tea) Teh CinaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//香片-茉莉花茶-Jasmine-Tea-10g-Chinese-Tea-中国茶叶(花茶)-(Scented-tea)-Teh-Cina-i.544698837.12833891783?sp_atk=10d64e1f-b58e-403c-8c02-1d2a0d069431",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/9cab3e881c7499a4c173153a657e254d_tn",
            "sold": "4 sold",
            "create_time": 1637748869000,
            "salePrice": "RM34.60",
            "price": "RM86.65",
            "product_id": 87,
            "place": "Mainland China",
            "title": "【品茶】十大名茶组合套装 白茶 红茶 金骏眉 正山小种 龙井 铁观音 肉桂 茉莉花茶 黑乌龙茶 大红袍 Top Ten Famous Tea Combination Set White Tea Black Tea Jinjunmei Zhengshan Race Longjing Tieguanyin Cinnamon Jasmine Tea Black Oolong Tea Dahongpao.RM2 offCOD",
            "url": "https://my.xiapibuy.com//【品茶】十大名茶组合套装-白茶-红茶-金骏眉-正山小种-龙井-铁观音-肉桂-茉莉花茶-黑乌龙茶-大红袍-Top-Ten-Famous-Tea-Combination-Set-White-Tea-Black-Tea-Jinjunmei-Zhengshan-Race-Longjing-Tieguanyin-Cinnamon-Jasmine-Tea-Black-Oolong-Tea-Dahongpao.-i.513884826.10046177133?sp_at",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/9b029df4ecdafa2f7d102f422c61ae0b_tn",
            "sold": "2 sold",
            "create_time": 1637748869000,
            "salePrice": "RM107.00",
            "price": "RM214.50",
            "product_id": 176,
            "place": "Mainland China",
            "title": "送茶具正山小种茶叶正宗武夷山金骏眉新茶长辈送礼红茶礼盒装Send Tea Set Zhengshan Race Tea Authentic Wuyishan Jinjunmei New Tea Elder Gift Black Tea Gift BoxCOD",
            "url": "https://my.xiapibuy.com//送茶具正山小种茶叶正宗武夷山金骏眉新茶长辈送礼红茶礼盒装Send-Tea-Set-Zhengshan-Race-Tea-Authentic-Wuyishan-Jinjunmei-New-Tea-Elder-Gift-Black-Tea-Gift-Box-i.513884826.9790577490?sp_atk=f04e86b3-8897-4cd2-a459-f712c8be1bee",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/7231b6ab83defc316bbf5d64d6661e7f_tn",
            "sold": "2.6k sold",
            "create_time": 1637748869000,
            "salePrice": "RM50.00",
            "price": "RM75.00",
            "product_id": 64,
            "place": "Selangor",
            "title": "中国茶叶 Chinese tea Teh 【100g x 3】 绿茶 大红袍 普洱 铁观音 黄金桂 水仙 乌龙茶 茉莉花茶 红茶 Puer Tea Green tea Black tea Jasmine Tea Tie guan yinShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//中国茶叶-Chinese-tea-Teh-【100g-x-3】-绿茶-大红袍-普洱-铁观音-黄金桂-水仙-乌龙茶-茉莉花茶-红茶-Puer-Tea-Green-tea-Black-tea-Jasmine-Tea-Tie-guan-yin-i.142200712.7006322272?sp_atk=9006eeed-798d-4823-8a3b-0f4b7a60f94c",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/344fc23ca43122f2c311d8d1d816371f_tn",
            "sold": "2 sold",
            "create_time": 1637748869000,
            "salePrice": "RM33.50 - RM60.20",
            "price": "",
            "product_id": 119,
            "place": "Mainland China",
            "title": "【 武夷山大红袍】正岩岩茶 浓香型肉桂 水仙奇兰 盒装250g 【Wuyishan Dahongpao】 Zhengyan Rock Tea Luzhou-flavor Cinnamon Narcissus Chilan Boxed 250g.RM2 offCOD",
            "url": "https://my.xiapibuy.com//【-武夷山大红袍】正岩岩茶-浓香型肉桂-水仙奇兰-盒装250g-【Wuyishan-Dahongpao】-Zhengyan-Rock-Tea-Luzhou-flavor-Cinnamon-Narcissus-Chilan-Boxed-250g.-i.513884826.11859947689?sp_atk=dbd801b3-d20a-4bc9-9b81-49aabe601372",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/95bd08e6d47b1408fd7164594825dc69_tn",
            "sold": "5 sold",
            "create_time": 1637748869000,
            "salePrice": "RM16.80",
            "price": "",
            "product_id": 19,
            "place": "Negeri Sembilan",
            "title": "茉莉花茶(香片）100g 盒装+礼袋 Jasmine Tea 100g + Free box + Paper bag Chinese Tea 中国茶叶(花茶)  (Scented tea) Teh Cina24% offShopMalaysia",
            "url": "https://my.xiapibuy.com//茉莉花茶(香片）100g-盒装-礼袋-Jasmine-Tea-100g-Free-box-Paper-bag-Chinese-Tea-中国茶叶(花茶)-(Scented-tea)-Teh-Cina-i.544698837.12338050682?sp_atk=74c388c1-1421-45a5-8ebd-b4c6c8c24cf4",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/4f4cb5b8c6505eb4d513456e26b9536b_tn",
            "sold": "162 sold",
            "create_time": 1637748869000,
            "salePrice": "RM15.88 - RM18.88",
            "price": "",
            "product_id": 114,
            "place": "Selangor",
            "title": "普洱茶 金骏眉 正山小种 大红袍 铁观音 茉莉花茶 高山绿茶 碧螺春 黄金桂茶 黑乌龙茶 龙景绿茶 毛尖 炭焙铁观音 奇兰 老叢水仙 肉桂 凤凰單叢 茶叶 chinese tea health Puer Da Hong Pao OolongShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//普洱茶-金骏眉-正山小种-大红袍-铁观音-茉莉花茶-高山绿茶-碧螺春-黄金桂茶-黑乌龙茶-龙景绿茶-毛尖-炭焙铁观音-奇兰-老叢水仙-肉桂-凤凰單叢-茶叶-chinese-tea-health-Puer-Da-Hong-Pao-Oolong-i.653343.9513923540?sp_atk=3172ac23-1bee-4700-aa7f-6e0156c6d3ba",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/79429c724821de56670160ef851a3865_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM13.16 - RM34.40",
            "price": "",
            "product_id": 149,
            "place": "Melaka",
            "title": "Pot four cups of tea black tea Jinjunmei壶四杯茶叶红茶金骏眉正山小种浓香型新茶礼盒小包装250glrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Pot-four-cups-of-tea-black-tea-Jinjunmei壶四杯茶叶红茶金骏眉正山小种浓香型新茶礼盒小包装250glrw3f3ycn7-i.431042679.13529834386?sp_atk=f30e8bb5-8b03-4ebf-8783-978921301060",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/5a4b7c2cf3ed6ac85d6e803a0aee95fd_tn",
            "sold": "494 sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.00",
            "price": "RM1.40",
            "product_id": 115,
            "place": "Kuala Lumpur",
            "title": "Dahongpao Tea [ High Quality ] 武夷山大红袍中国茶一包ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Dahongpao-Tea-High-Quality-武夷山大红袍中国茶一包-i.10534598.6258664132?sp_atk=d9b057cb-a870-4460-a97f-55ea5caf5f3d",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/8eb853fe863753be17f3c036c04e5fcc_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM22.68 - RM43.48",
            "price": "",
            "product_id": 43,
            "place": "Mainland China",
            "title": "Tea bag bag disposable soup coffee bag filter jasmine tea corn fiber triangle tea bag food pole茶包袋一次性煲汤咖啡袋过滤茉莉花茶玉米纤维三角泡茶叶袋食品极zhangli888.my 5.15RM1 offCOD",
            "url": "https://my.xiapibuy.com//Tea-bag-bag-disposable-soup-coffee-bag-filter-jasmine-tea-corn-fiber-triangle-tea-bag-food-pole茶包袋一次性煲汤咖啡袋过滤茉莉花茶玉米纤维三角泡茶叶袋食品极zhangli888.my-5.15-i.485318768.10467227861?sp_atk=643d6508-454b-4ff0-a7c3-cccb42574e77",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/d03aedce405b4801c268768f7aa9246d_tn",
            "sold": "50 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.58",
            "price": "",
            "product_id": 157,
            "place": "Melaka",
            "title": "茶叶 小袋 散装包 普洱茶 碧螺春 毛尖茶 黄金桂 铁观音 绿茶 正山小种 金丝皇菊 茉莉花茶 黑乌龙茶 大红袍 龙井 炭焙铁观音 金骏眉 中国茶叶 #浓香 #现货 #chinese tea pack #ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茶叶-小袋-散装包-普洱茶-碧螺春-毛尖茶-黄金桂-铁观音-绿茶-正山小种-金丝皇菊-茉莉花茶-黑乌龙茶-大红袍-龙井-炭焙铁观音-金骏眉-中国茶叶-浓香-现货-chinese-tea-pack--i.396483765.12247654293?sp_atk=837f5b02-8530-4d2f-9f88-a39e8825e88f",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/9fe8c7d588b99ff8e27239de38af0053_tn",
            "sold": "1.4k sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.00",
            "price": "",
            "product_id": 39,
            "place": "Selangor",
            "title": "茉莉花茶 | 香片 Jasmine Tea【6 packs x 8g】| 【 Scented tea 花茶 】 Chinese Tea 中国茶叶 Teh Cina 中国茶 茶叶 茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茉莉花茶-香片-Jasmine-Tea【6-packs-x-8g】-【-Scented-tea-花茶-】-Chinese-Tea-中国茶叶-Teh-Cina-中国茶-茶叶-茶-i.142200712.5700853274?sp_atk=dcb2fa93-c1cf-40f4-9f57-33cdd645cf2f",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/a576ac0fb90a806531be75a8c01066b2_tn",
            "sold": "604 sold",
            "create_time": 1637748869000,
            "salePrice": "RM21.08",
            "price": "RM26.34",
            "product_id": 68,
            "place": "Kuala Lumpur",
            "title": "大红袍茶叶 罐装散装250g （1罐） Da Hong Pao TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//大红袍茶叶-罐装散装250g-（1罐）-Da-Hong-Pao-Tea-i.266929667.3355939218?sp_atk=738fb78b-081a-4087-a56f-c2c9c2f05987",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/1af17848060566b14fda63ab1c149f41_tn",
            "sold": "21 sold",
            "create_time": 1637748869000,
            "salePrice": "RM4.70",
            "price": "",
            "product_id": 40,
            "place": "Kuala Lumpur",
            "title": "Sprouting Brand JT001 Jasmine Tea Bags (40g) 新芽牌茉莉花茶袋泡茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Sprouting-Brand-JT001-Jasmine-Tea-Bags-(40g)-新芽牌茉莉花茶袋泡茶-i.290454622.8062677188?sp_atk=b45e6137-734b-4b97-9bf7-58f04a93198a",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f2ca9597d39b4d0a4e64efa92ba448bd_tn",
            "sold": "35.7k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.49 - RM0.89",
            "price": "",
            "product_id": 69,
            "place": "Kedah",
            "title": "【中国茶小袋装】铁观音 大红袍 黑乌龙 普洱 5-7g Chinese TeasShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【中国茶小袋装】铁观音-大红袍-黑乌龙-普洱-5-7g-Chinese-Teas-i.15549999.9328673007?sp_atk=90fc5670-2d96-45f2-a5aa-dd963f7e89f6",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/c83ecef3e9b08b2c1345a97e3d42ef81_tn",
            "sold": "35 sold",
            "create_time": 1637748869000,
            "salePrice": "RM7.99",
            "price": "",
            "product_id": 52,
            "place": "Perak",
            "title": "渝达 茉莉绿茶 Jasmine Green Tea 排毒养颜 花茶50% offLocal Seller",
            "url": "https://my.xiapibuy.com//渝达-茉莉绿茶-Jasmine-Green-Tea-排毒养颜-花茶-i.277548324.5386869197?sp_atk=cada7082-e1f9-437e-809a-06e7482dfd69",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/1de3a214d63451795be165637f46e29f_tn",
            "sold": "19 sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.00",
            "price": "",
            "product_id": 96,
            "place": "Selangor",
            "title": "【一罐茶】九味口粮茶 绿茶 茉莉花茶  碧螺春 铁观音 大红袍 正山小种 正岩肉桂 金骏眉 普洱茶 | Chinese Tea | Chinese Can Tea | Chinese Cup Tea |ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【一罐茶】九味口粮茶-绿茶-茉莉花茶-碧螺春-铁观音-大红袍-正山小种-正岩肉桂-金骏眉-普洱茶-Chinese-Tea-Chinese-Can-Tea-Chinese-Cup-Tea--i.521239025.8291353601?sp_atk=702a7bf5-b2e3-445a-a737-9c1a3817ae65",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/1de3a214d63451795be165637f46e29f_tn",
            "sold": "19 sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.00",
            "price": "",
            "product_id": 166,
            "place": "Selangor",
            "title": "【一罐茶】九味口粮茶 绿茶 茉莉花茶  碧螺春 铁观音 大红袍 正山小种 正岩肉桂 金骏眉 普洱茶 | Chinese Tea | Chinese Can Tea | Chinese Cup Tea |ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【一罐茶】九味口粮茶-绿茶-茉莉花茶-碧螺春-铁观音-大红袍-正山小种-正岩肉桂-金骏眉-普洱茶-Chinese-Tea-Chinese-Can-Tea-Chinese-Cup-Tea--i.521239025.8291353601?sp_atk=722e5307-d30b-4536-92bd-02124bb87d51",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/5a2cb1dcef531440d1775bc23eb48cc6_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM38.00",
            "price": "RM98.00",
            "product_id": 179,
            "place": "Kuala Lumpur",
            "title": "璞卉精选武夷山正山小种茶罐装红茶中国名茶PohHuey selection, Wuyishan, Lapsang Souchong tea, canned black tea, Chinese famous teaCOD",
            "url": "https://my.xiapibuy.com//璞卉精选武夷山正山小种茶罐装红茶中国名茶PohHuey-selection-Wuyishan-Lapsang-Souchong-tea-canned-black-tea-Chinese-famous-tea-i.515626905.13224784986?sp_atk=eeb0b949-1cc1-4099-a0f0-f1d32b47e4dc",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/605fd96b57057eb74259ebf0e4aac3fd_tn",
            "sold": "15.1k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.48 - RM0.59",
            "price": "",
            "product_id": 24,
            "place": "Perak",
            "title": "【Ready Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶 (Hot-selling Chinese tea with strong flavor: Tieguanyin etc）ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【Ready-Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶-(Hot-selling-Chinese-tea-with-strong-flavor-Tieguanyin-etc）-i.171504495.9139346773?sp_atk=9a652967-8a9f-464c-a62b-66000758b60b",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/83fcb079c825e3c2b7aa9e25aafbf3b7_tn",
            "sold": "148 sold",
            "create_time": 1637748869000,
            "salePrice": "RM33.73 - RM44.98",
            "price": "",
            "product_id": 83,
            "place": "Mainland China",
            "title": "Wuyishan Zhengyan Dahongpao Tea New Tea Luzhou-flavored Cinn武夷山正岩大红袍茶叶新茶浓香型肉桂春茶高山乌龙茶散装罐装250gweixianyuanming.myEconomyDeliveryFree Gift",
            "url": "https://my.xiapibuy.com//Wuyishan-Zhengyan-Dahongpao-Tea-New-Tea-Luzhou-flavored-Cinn武夷山正岩大红袍茶叶新茶浓香型肉桂春茶高山乌龙茶散装罐装250gweixianyuanming.my-i.202931586.9017785784?sp_atk=025f6f5d-5c55-44db-8c01-2561c1a76fcb",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/9a99b82d5242a193f19b8f8439a0cd8c_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM0.75 - RM4.50",
            "price": "",
            "product_id": 38,
            "place": "Selangor",
            "title": "Flower Tea mix & match 花茶搭配 [Rose玫瑰 , Jasmine茉莉, Roselle洛神花 , Lavender薰衣草 , Chamomile洋甘菊 , Lily百合, Apple Flower苹果花 ]ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Flower-Tea-mix-match-花茶搭配-Rose玫瑰-Jasmine茉莉-Roselle洛神花-Lavender薰衣草-Chamomile洋甘菊-Lily百合-Apple-Flower苹果花--i.316348212.13311467052?sp_atk=6c6b0c1f-bfa3-47db-8ef9-44501186be51",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/49e96ba1eb1bf73f61830711a4118a29_tn",
            "sold": "9 sold",
            "create_time": 1637748869000,
            "salePrice": "RM7.89 - RM9.99",
            "price": "",
            "product_id": 84,
            "place": "Johor",
            "title": "金骏眉铁观音茶叶茉莉花茶大红袍组合茶 Jin Junmei Tieguanyin Tea Jasmine Tea Dahongpao Combination TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//金骏眉铁观音茶叶茉莉花茶大红袍组合茶-Jin-Junmei-Tieguanyin-Tea-Jasmine-Tea-Dahongpao-Combination-Tea-i.252245248.11041292944?sp_atk=2429d67c-777b-45ef-bf01-5a1cd9093bb2",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/771d3735d8d99e93862033146450d88f_tn",
            "sold": "1 sold",
            "create_time": 1637748869000,
            "salePrice": "RM55.80",
            "price": "RM60.00",
            "product_id": 1,
            "place": "Selangor",
            "title": "龙地山特级茉莉花茶 罐装送礼佳品 250克 LongDiShan Yun Nan Jasmine Tea 250g【现货 | Ready Stock】24% offShopMalaysia",
            "url": "https://my.xiapibuy.com//龙地山特级茉莉花茶-罐装送礼佳品-250克-LongDiShan-Yun-Nan-Jasmine-Tea-250g【现货-Ready-Stock】-i.97541639.6297459534?sp_atk=c4fe9940-a57c-40ae-8c94-7d5badb9e41e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/5f8439936804e7040b6b6963a62d4185_tn",
            "sold": "4.9k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.45",
            "price": "RM2.00",
            "product_id": 66,
            "place": "Kuala Lumpur",
            "title": "{READY STOCK}{中国茶小袋装} 大红袍 铁观音 金骏眉 黑乌龙 普洱茶 6-8g Individual Pack Chinese Tea Tie Guan Yin Da Hong Pao Jasmine Tea Teh CinaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//-READY-STOCK-中国茶小袋装-大红袍-铁观音-金骏眉-黑乌龙-普洱茶-6-8g-Individual-Pack-Chinese-Tea-Tie-Guan-Yin-Da-Hong-Pao-Jasmine-Tea-Teh-Cina-i.421424331.6297246712?sp_atk=3fedc089-d6b2-493e-935b-76937b99e96a",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/cc067c5d681605dcbe367bea6d94c98e_tn",
            "sold": "7 sold",
            "create_time": 1637748869000,
            "salePrice": "RM11.00 - RM33.50",
            "price": "",
            "product_id": 178,
            "place": "Mainland China",
            "title": "新茶武夷山正山小种红茶罐装桐木关金骏眉茶叶New Tea Wuyishan Zhengshan Race Black Tea Canned Tongmuguan Jinjunmei TeaCODAdd-on Deal",
            "url": "https://my.xiapibuy.com//新茶武夷山正山小种红茶罐装桐木关金骏眉茶叶New-Tea-Wuyishan-Zhengshan-Race-Black-Tea-Canned-Tongmuguan-Jinjunmei-Tea-i.513884826.10830566875?sp_atk=327dd710-d498-4c27-9f26-f8d38f78d827",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/086acfa818c7f5ac7c3d5ceea157457b_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM15.99",
            "price": "RM16.50",
            "product_id": 33,
            "place": "Melaka",
            "title": "铁罐装茶叶 碧螺春 普洱茶 正山小种 金骏眉 茉莉花茶 铁观音 绿茶 大红袍 中国茶叶 #chinese tea #各类式 #名茶 #浓香ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//铁罐装茶叶-碧螺春-普洱茶-正山小种-金骏眉-茉莉花茶-铁观音-绿茶-大红袍-中国茶叶-chinese-tea-各类式-名茶-浓香-i.396483765.10770414275?sp_atk=35cdb236-5ed4-4c32-98f8-c9fc3d593c08",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/cb83f79b2c5e8929e0249fd6f23ac66a_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM14.50",
            "price": "",
            "product_id": 154,
            "place": "Terengganu",
            "title": "正山小种茶（50gX10小包）Lapsang Souchong Tea24% offShopMalaysia",
            "url": "https://my.xiapibuy.com//正山小种茶（50gX10小包）Lapsang-Souchong-Tea-i.511960624.12030818854?sp_atk=86d80743-7ebf-41e5-a390-4cac13b71a0e",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/15d3d2593f2d8359f1bad56320c840e6_tn",
            "sold": "12 sold",
            "create_time": 1637748869000,
            "salePrice": "RM6.50 - RM8.90",
            "price": "",
            "product_id": 25,
            "place": "Negeri Sembilan",
            "title": "【花茶系列】Premium Chrysanthemums Buds 胎菊/France Rose 法国玫瑰/Jasmine Tea 茉莉花茶/Osmanthus Flower 桂花/Gynostemma Pentaphyllum 绞股蓝ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【花茶系列】Premium-Chrysanthemums-Buds-胎菊-France-Rose-法国玫瑰-Jasmine-Tea-茉莉花茶-Osmanthus-Flower-桂花-Gynostemma-Pentaphyllum-绞股蓝-i.268027425.7171736459?sp_atk=89d97a18-6ece-42a0-b3d1-1af579db8377",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/92ba8c56e8af2d82fff92062b2fb8dd3_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM20.40 - RM81.14",
            "price": "",
            "product_id": 152,
            "place": "Mainland China",
            "title": "The Small Authentic Martial The Tea Conservation 2021 New Tea Flavor Tea Leaf正山小种正宗武夷山红茶养胃2021新茶浓香型做奶茶叶散袋装nzaldz15.my10.21RM2 offAny 2 enjoy RM1.00 off",
            "url": "https://my.xiapibuy.com//The-Small-Authentic-Martial-The-Tea-Conservation-2021-New-Tea-Flavor-Tea-Leaf正山小种正宗武夷山红茶养胃2021新茶浓香型做奶茶叶散袋装nzaldz15.my10.21-i.197262226.13233269558?sp_atk=cd023af8-9c87-424a-b25a-823ba24f2a85",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/e11ab7908094ed78b6662115e79c3f01_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM6.90",
            "price": "",
            "product_id": 32,
            "place": "Kuala Lumpur",
            "title": "Nongfu Spring Oriental Leaf Sugar Free Drink Jasmine Tea - 500ml 农夫山泉 东方树叶 无糖饮料 茉莉花茶 - 500mlShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Nongfu-Spring-Oriental-Leaf-Sugar-Free-Drink-Jasmine-Tea-500ml-农夫山泉-东方树叶-无糖饮料-茉莉花茶-500ml-i.98811036.10544993438?sp_atk=236272c9-f579-4ab8-968a-04504d3f669e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/7c8d1ac5691ff08e8525c25271852f38_tn",
            "sold": "28 sold",
            "create_time": 1637748869000,
            "salePrice": "RM35.00",
            "price": "",
            "product_id": 90,
            "place": "Selangor",
            "title": "奇兰香大红袍 Qi Lan Xiang Da Hong Pao 【100g】韵香 大红袍 武夷岩茶 Wu Yi Rock Tea Oolong tea |  Teh Cina  中国茶 中国茶叶 茶叶 Chinese TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//奇兰香大红袍-Qi-Lan-Xiang-Da-Hong-Pao-【100g】韵香-大红袍-武夷岩茶-Wu-Yi-Rock-Tea-Oolong-tea-Teh-Cina-中国茶-中国茶叶-茶叶-Chinese-Tea-i.142200712.11440423238?sp_atk=f77cd0ec-f6b9-4629-98e8-ad5d4d0fe166",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/77355b0c2469c69c75dab75e59f840ab_tn",
            "sold": "12 sold",
            "create_time": 1637748869000,
            "salePrice": "RM23.00",
            "price": "",
            "product_id": 46,
            "place": "Kuala Lumpur",
            "title": "Sunflower Brand 1032 Jasmine Tea (227g) 向阳花牌茉莉花茶RM0.5 offShopMalaysia",
            "url": "https://my.xiapibuy.com//Sunflower-Brand-1032-Jasmine-Tea-(227g)-向阳花牌茉莉花茶-i.290454622.9209712992?sp_atk=cece19d8-eab2-40a0-8bed-58ad3be36f5e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/42da57d47953b797d878a544b1987613_tn",
            "sold": "753 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.76",
            "price": "RM3.60",
            "product_id": 22,
            "place": "Johor",
            "title": "现货农夫山泉茶兀果茶系列/茶派/柚子绿茶/玫瑰荔枝红茶/蜜桃乌龙茶/柠檬红茶/西柚茉莉花茶 Nongfu Spring Cha Pai Cha Pie 茶π 茶派 Fruit Tea 500MLLocal SellerCOD",
            "url": "https://my.xiapibuy.com//现货农夫山泉茶兀果茶系列-茶派-柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-Nongfu-Spring-Cha-Pai-Cha-Pie-茶π-茶派-Fruit-Tea-500ML-i.530265655.13637249041?sp_atk=3a17af28-bf34-4d7a-9a6f-10f2261ded04",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/6678fb9d28740629583b2f1f09225754_tn",
            "sold": "2 sold",
            "create_time": 1637748869000,
            "salePrice": "RM28.00 - RM58.50",
            "price": "",
            "product_id": 180,
            "place": "Mainland China",
            "title": "金骏眉正山小种250g/500g茶叶红茶礼盒装浓香型Jinjunmei Zhengshan Race 250g/500g Tea Black Tea Gift Box Luzhou-flavorRM2 offCOD",
            "url": "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶礼盒装浓香型Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-Gift-Box-Luzhou-flavor-i.513884826.11830571124?sp_atk=633c1c54-ab63-4e0f-a0fa-8844263d2ec2",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/49e96ba1eb1bf73f61830711a4118a29_tn",
            "sold": "9 sold",
            "create_time": 1637748869000,
            "salePrice": "RM7.89 - RM9.99",
            "price": "",
            "product_id": 20,
            "place": "Johor",
            "title": "金骏眉铁观音茶叶茉莉花茶大红袍组合茶 Jin Junmei Tieguanyin Tea Jasmine Tea Dahongpao Combination TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//金骏眉铁观音茶叶茉莉花茶大红袍组合茶-Jin-Junmei-Tieguanyin-Tea-Jasmine-Tea-Dahongpao-Combination-Tea-i.252245248.11041292944?sp_atk=08dc7b9c-5236-4510-ba85-b7b72cf2a082",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/5745001b1a2bed6e073a21c1a399f386_tn",
            "sold": "3 sold",
            "create_time": 1637748869000,
            "salePrice": "RM10.90",
            "price": "",
            "product_id": 161,
            "place": "Selangor",
            "title": "Red Tea 正山小种金骏眉红茶 125gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Red-Tea-正山小种金骏眉红茶-125g-i.107485006.4586644324?sp_atk=6edb161b-833d-42ec-ad43-e99c4c9de32b",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/db5738eb73e1b111467421f84b8e64b7_tn",
            "sold": "67 sold",
            "create_time": 1637748869000,
            "salePrice": "RM72.21",
            "price": "RM83.00",
            "product_id": 107,
            "place": "Selangor",
            "title": "武夷山正岩大红袍茶叶武夷岩茶水仙肉桂茶500g浓香型散装礼盒罐装Wuyishan Zhengyan Dahongpao Tea Wuyiyan Tea Narcissus Cinnamon Tea 500g Chinese TeaRM5 offShopMalaysia",
            "url": "https://my.xiapibuy.com//武夷山正岩大红袍茶叶武夷岩茶水仙肉桂茶500g浓香型散装礼盒罐装Wuyishan-Zhengyan-Dahongpao-Tea-Wuyiyan-Tea-Narcissus-Cinnamon-Tea-500g-Chinese-Tea-i.162023644.5125929393?sp_atk=299fef13-5a69-4a74-b0e5-03a796265428",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/342c60622b1629534713a7b4581a4848_tn",
            "sold": "154 sold",
            "create_time": 1637748869000,
            "salePrice": "RM15.75",
            "price": "RM22.50",
            "product_id": 129,
            "place": "Kuala Lumpur",
            "title": "武夷红茶署香味正山小种独立小袋装礼盒装福建茶叶 125g (25s) Zheng Shan Xiao Zhong Black Tea 125gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//武夷红茶署香味正山小种独立小袋装礼盒装福建茶叶-125g-(25s)-Zheng-Shan-Xiao-Zhong-Black-Tea-125g-i.266929667.7560137504?sp_atk=af57c851-7d6d-4ae5-8114-366738a501a9",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f73c25a67d0de2457c79252fb3d09b4a_tn",
            "sold": "917 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.99 - RM1.20",
            "price": "",
            "product_id": 104,
            "place": "Selangor",
            "title": "散装茶叶小包装 铁观音 大红袍 金骏眉 高山绿茶 碧螺春 普洱熟茶 龙井 5g Tie Guan Yin Da Hong Pao Puer teh Jasmine teaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//散装茶叶小包装-铁观音-大红袍-金骏眉-高山绿茶-碧螺春-普洱熟茶-龙井-5g-Tie-Guan-Yin-Da-Hong-Pao-Puer-teh-Jasmine-tea-i.10462357.9339083705?sp_atk=c2dfdf2d-68c6-4f11-bda5-57c42d57c7c9",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/0665d3d48c5b6ce25b5c5952b698f438_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM27.00 - RM61.00",
            "price": "",
            "product_id": 159,
            "place": "Mainland China",
            "title": "Zhengshan Xiaozhong 2021 new tea super black tea milk tea sp正山小种2021新茶特级红茶奶茶专用蜜香养胃浓香型红茶茶叶批发sxhxdkxx.my9.23RM6 offFree Gift",
            "url": "https://my.xiapibuy.com//Zhengshan-Xiaozhong-2021-new-tea-super-black-tea-milk-tea-sp正山小种2021新茶特级红茶奶茶专用蜜香养胃浓香型红茶茶叶批发sxhxdkxx.my9.23-i.204153794.13914818402?sp_atk=3db03b5d-0846-4372-897a-d5944d6215fd",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/c31ab07142288816e1ce81a5cbef3617_tn",
            "sold": "60 sold",
            "create_time": 1637748869000,
            "salePrice": "RM39.98 - RM176.00",
            "price": "",
            "product_id": 94,
            "place": "Mainland China",
            "title": "Wuyi Rock Tea Dahongpao Jin Junmei Lapsang Souchong Black Te武夷岩茶大红袍金骏眉正山小种红茶叶木桶散装罐装礼盒装500g礼weixianyuanming.myFree Gift",
            "url": "https://my.xiapibuy.com//Wuyi-Rock-Tea-Dahongpao-Jin-Junmei-Lapsang-Souchong-Black-Te武夷岩茶大红袍金骏眉正山小种红茶叶木桶散装罐装礼盒装500g礼weixianyuanming.my-i.202931586.8718704089?sp_atk=25c66921-027d-49f0-bc63-1397317aeb40",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/f07f03d8d5e404a423fcb0a7389a82f8_tn",
            "sold": "118 sold",
            "create_time": 1637748869000,
            "salePrice": "RM8.90",
            "price": "RM9.50",
            "product_id": 10,
            "place": "Kuala Lumpur",
            "title": "????现货????精美铁盒+单独包装 中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 Chinese Tea Da Hong Pao Puer Tie Guan YinShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//????现货????精美铁盒-单独包装-中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-Chinese-Tea-Da-Hong-Pao-Puer-Tie-Guan-Yin-i.128031579.12917419602?sp_atk=03fb6e5d-1708-45a6-868d-906a43cf1640",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/57375897649eef3d0246fe128656abba_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM351.44",
            "price": "RM585.73",
            "product_id": 168,
            "place": "Mainland China",
            "title": "Eight horses lapsang souchong tea level wuyi tea large quant八马茶叶 一级正山小种武夷山红茶大份量商务高端送礼礼盒装500g10.17RM15 off",
            "url": "https://my.xiapibuy.com//Eight-horses-lapsang-souchong-tea-level-wuyi-tea-large-quant八马茶叶-一级正山小种武夷山红茶大份量商务高端送礼礼盒装500g10.17-i.189804488.9795473419?sp_atk=ce509e76-fb30-4621-8dcc-f48a69d83608",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/dc097be3d72532ade25af899ea06131e_tn",
            "sold": "10 sold",
            "create_time": 1637748869000,
            "salePrice": "RM16.90",
            "price": "",
            "product_id": 60,
            "place": "Pahang",
            "title": "茉莉薄荷茶(30包)Jasmine Mint Tea 90gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茉莉薄荷茶(30包)Jasmine-Mint-Tea-90g-i.39251387.9910850233?sp_atk=f9b00f31-a87a-47b2-b1b2-be8e70c29c7e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/611616c5c3c382d2f4359d299a8b1384_tn",
            "sold": "306 sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.50",
            "price": "RM1.55",
            "product_id": 111,
            "place": "Penang",
            "title": "2020新茶 武夷大红袍茶叶 肉桂岩茶 Dahongpao TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//2020新茶-武夷大红袍茶叶-肉桂岩茶-Dahongpao-Tea-i.60201032.5284150983?sp_atk=5c21fa02-cf34-4b7f-97cd-e4f30e70a8f6",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/f27a5923c63a2503235c30afb34264a5_tn",
            "sold": "9.7k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.45 - RM1.12",
            "price": "",
            "product_id": 36,
            "place": "Perak",
            "title": "【COH】养生茶 Flower Tea Teh Bunga 【壹间草药】Doorgift 花茶 养生花茶 红枣 菊花 玫瑰 山楂 柠檬 茉莉 桂圆 龙眼 决明子 枸杞 胎菊 金银花 瘦身 减肥 养肝茶 抗氧化 美白 祛痘ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【COH】养生茶-Flower-Tea-Teh-Bunga-【壹间草药】Doorgift-花茶-养生花茶-红枣-菊花-玫瑰-山楂-柠檬-茉莉-桂圆-龙眼-决明子-枸杞-胎菊-金银花-瘦身-减肥-养肝茶-抗氧化-美白-祛痘-i.26353660.4685937736?sp_atk=5ba01d24-0c62-4fb9-8d4b-193968bd5b69",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/68906710acf7f0187e967116cc88ace5_tn",
            "sold": "17 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.59",
            "price": "",
            "product_id": 31,
            "place": "Johor",
            "title": "农夫山泉 茶兀 茶派 柚子绿茶 玫瑰荔枝红茶 蜜桃乌龙茶 柠檬红茶 西柚茉莉花茶 500ml NongFu Spring Fruit Tea 500mShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//农夫山泉-茶兀-茶派-柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-500ml-NongFu-Spring-Fruit-Tea-500m-i.277296017.14301040296?sp_atk=9ea11dcb-6b22-442a-8b01-8669751df7b7",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f30bd01cfa39ca1f121e807718144767_tn",
            "sold": "3.3k sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.01",
            "price": "RM5.00",
            "product_id": 75,
            "place": "Negeri Sembilan",
            "title": "武夷山大红袍 5g 中国茶 Dahongpao Tea 1 pack 5g(26 packs=1box)ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//武夷山大红袍-5g-中国茶-Dahongpao-Tea-1-pack-5g(26-packs-1box)-i.26435989.4967239930?sp_atk=87039b3d-61ce-47b8-aeda-ce37f921b65c",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/23e3de3453e478bb125a79485dbe397d_tn",
            "sold": "2 sold",
            "create_time": 1637748869000,
            "salePrice": "RM74.00 - RM89.80",
            "price": "",
            "product_id": 117,
            "place": "Mainland China",
            "title": "绿茶雨前龙井 铁观音 金骏眉 大红袍 新茶叶礼盒装散装送礼高档佳品清香型 Green tea, Longjing Tieguanyin Jinjunmei Dahongpao, new tea gift boxes, bulk gifts, high-end products and delicate fragrance.RM5 offCOD",
            "url": "https://my.xiapibuy.com//绿茶雨前龙井-铁观音-金骏眉-大红袍-新茶叶礼盒装散装送礼高档佳品清香型-Green-tea-Longjing-Tieguanyin-Jinjunmei-Dahongpao-new-tea-gift-boxes-bulk-gifts-high-end-products-and-delicate-fragrance.-i.513884826.11546337011?sp_atk=b3571530-4aaf-4fa5-a9b9-6b1c549754e8",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/f134d9420add60ccda852f7ababfb785_tn",
            "sold": "234 sold",
            "create_time": 1637748869000,
            "salePrice": "RM11.66",
            "price": "RM16.65",
            "product_id": 142,
            "place": "Kuala Lumpur",
            "title": "六大茗茶70克（12小包）铁观音黑乌龙茶.绿茶.金骏眉.大红袍.正山小种茶叶 Assorted Chinese TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//六大茗茶70克（12小包）铁观音黑乌龙茶.绿茶.金骏眉.大红袍.正山小种茶叶-Assorted-Chinese-Tea-i.266929667.4978205463?sp_atk=3a04d4df-be41-4001-aedd-cb3433ab9278",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/e20cde044b6fa7c4db293bb3e4933f98_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM19.35 - RM62.03",
            "price": "",
            "product_id": 170,
            "place": "Mainland China",
            "title": "【红茶】新茶 金骏眉小包装茶叶 蜜香武夷山正山小种 黄芽浓香型 礼盒装 【Black Tea】 New Tea Jinjunmei Small Package Tea Honey Fragrance Wuyishan Zhengshan Race Yellow Bud Luzhou-flavor Gift Box.RM2 offCOD",
            "url": "https://my.xiapibuy.com//【红茶】新茶-金骏眉小包装茶叶-蜜香武夷山正山小种-黄芽浓香型-礼盒装-【Black-Tea】-New-Tea-Jinjunmei-Small-Package-Tea-Honey-Fragrance-Wuyishan-Zhengshan-Race-Yellow-Bud-Luzhou-flavor-Gift-Box.-i.513884826.12939310106?sp_atk=412cd17f-b6a8-4601-b4dd-9caba9ea073b",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/22d78d2f88bc1d61b24c6298224e5ed2_tn",
            "sold": "949 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.55",
            "price": "RM1.10",
            "product_id": 121,
            "place": "Penang",
            "title": "福建红茶正山小种茶叶 6g Fujian Black Tea Zhengshan Small TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//福建红茶正山小种茶叶-6g-Fujian-Black-Tea-Zhengshan-Small-Tea-i.60201032.3338624999?sp_atk=9e9aa90e-1890-478d-9b33-4f557c51468a",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/8daf4ce2a80b8917f04a3b708c416983_tn",
            "sold": "41 sold",
            "create_time": 1637748869000,
            "salePrice": "RM78.84 - RM294.84",
            "price": "",
            "product_id": 131,
            "place": "Johor",
            "title": "【红茶】云南古树红茶 正山小种 金骏眉   50克 降血糖、降血压、降血脂、防治心肌梗塞  【Red Tea】Yunnan Red Tea  50gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【红茶】云南古树红茶-正山小种-金骏眉-50克-降血糖、降血压、降血脂、防治心肌梗塞-【Red-Tea】Yunnan-Red-Tea-50g-i.305390642.3757147560?sp_atk=3695fdac-a657-4be4-8b51-a847fd15345e",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/d89a20c268eb8fc6df54fc58416e2211_tn",
            "sold": "3 sold",
            "create_time": 1637748869000,
            "salePrice": "RM68.00 - RM82.00",
            "price": "",
            "product_id": 172,
            "place": "Mainland China",
            "title": "Holiday gift Dahongpao tea gift box Wuyishan Lapsang Souchon节日礼 大红袍茶叶礼盒装 武夷山正山小种 金骏眉红茶肉桂散装????抽BOSS百货店????Free Gift",
            "url": "https://my.xiapibuy.com//Holiday-gift-Dahongpao-tea-gift-box-Wuyishan-Lapsang-Souchon节日礼-大红袍茶叶礼盒装-武夷山正山小种-金骏眉红茶肉桂散装????抽BOSS百货店????-i.427603284.8949396338?sp_atk=6966c5b4-3dec-4f24-aef6-2cb1168a1afd",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/81b5b49c12b319e3571e5cf271be2936_tn",
            "sold": "3 sold",
            "create_time": 1637748869000,
            "salePrice": "RM9.90",
            "price": "RM24.00",
            "product_id": 125,
            "place": "Kuala Lumpur",
            "title": "Lapsang Souchong Tea正山小种茶（50gX10小包）ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Lapsang-Souchong-Tea正山小种茶（50gX10小包）-i.278239141.10904406225?sp_atk=eddae625-eb54-437e-95d9-d372ebf293f8",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/53684d080e50ca5ba7ccb2612f93c6fd_tn",
            "sold": "41 sold",
            "create_time": 1637748869000,
            "salePrice": "RM25.90",
            "price": "",
            "product_id": 57,
            "place": "Perak",
            "title": "1袋50包 菊花决明子茶 Chrysanthemum Cassia Seed Tea 养生茶 清肝泻火50% offLocal Seller",
            "url": "https://my.xiapibuy.com//1袋50包-菊花决明子茶-Chrysanthemum-Cassia-Seed-Tea-养生茶-清肝泻火-i.277548324.8854696427?sp_atk=bc389f05-a764-44d8-944c-5fb90ce67b62",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/2e3b3a3829d6cb2501102148c7787dbe_tn",
            "sold": "36 sold",
            "create_time": 1637748869000,
            "salePrice": "RM20.70",
            "price": "RM42.30",
            "product_id": 70,
            "place": "Mainland China",
            "title": "[武夷岩茶大红袍]茶叶礼盒250g罐装炭焙浓香乌龙茶春茶岩茶肉桂红茶中国茶[Wuyi Rock Tea Dahongpao] Tea Gift Box 250g Canned Carbon Baked Luzhou Oolong Tea Spring Tea Rock Tea Cinnamon Black Tea Chinese TeaRM2 offCOD",
            "url": "https://my.xiapibuy.com//-武夷岩茶大红袍-茶叶礼盒250g罐装炭焙浓香乌龙茶春茶岩茶肉桂红茶中国茶-Wuyi-Rock-Tea-Dahongpao-Tea-Gift-Box-250g-Canned-Carbon-Baked-Luzhou-Oolong-Tea-Spring-Tea-Rock-Tea-Cinnamon-Black-Tea-Chinese-Tea-i.513884826.10041732363?sp_atk=32e64c27-ba0c-4dd8-861c-0cfebd",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/c6ac6bd7f3863efac41ab32e1e9b4882_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM15.84 - RM47.36",
            "price": "",
            "product_id": 130,
            "place": "Melaka",
            "title": "Ye Song Tea Black Tea Lapsang Souchong J叶颂茶叶 红茶正山小种金骏眉 大红袍 铁观音多款任选 礼盒装新茶lrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Ye-Song-Tea-Black-Tea-Lapsang-Souchong-J叶颂茶叶-红茶正山小种金骏眉-大红袍-铁观音多款任选-礼盒装新茶lrw3f3ycn7-i.431042679.13004573231?sp_atk=d8ef0cdc-6e72-47fb-b417-c5b967202870",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/d04aba69aa6942a0e4bac29aeb80f359_tn",
            "sold": "3 sold",
            "create_time": 1637748869000,
            "salePrice": "RM12.58",
            "price": "RM14.80",
            "product_id": 41,
            "place": "Selangor",
            "title": "100g Chinese Tea tie guan yin biluo chun Green Tea Jasmine Tea 铁观音 高山绿茶 碧罗春 茉莉花茶 100 gramShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//100g-Chinese-Tea-tie-guan-yin-biluo-chun-Green-Tea-Jasmine-Tea-铁观音-高山绿茶-碧罗春-茉莉花茶-100-gram-i.10462357.13204699705?sp_atk=c886bee1-38ef-43ea-acfd-f4f155f6106a",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/f96736bd94306e525407511b975a6b48_tn",
            "sold": "4k sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.05 - RM3.48",
            "price": "",
            "product_id": 2,
            "place": "Negeri Sembilan",
            "title": "Ccmc.Flower Tea Bag/Teh Bunga Floral Tea 花茶 herbal 菊花决明子茶桂圆红枣茶胖大海菊花茶五宝茶男人茶罗汉果红豆薏米芡实茶菊苣栀子茶冬瓜荷叶茶冬瓜茶脂流茶玉米须桑叶茶草本三清茶酸梅汤ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Ccmc.Flower-Tea-Bag-Teh-Bunga-Floral-Tea-花茶-herbal-菊花决明子茶桂圆红枣茶胖大海菊花茶五宝茶男人茶罗汉果红豆薏米芡实茶菊苣栀子茶冬瓜荷叶茶冬瓜茶脂流茶玉米须桑叶茶草本三清茶酸梅汤-i.51183430.8632561564?sp_atk=66e4e298-6651-4f8b-b9ef-d178dc199446",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/161d31e7028f7d5a91ff9e9035d96fa8_tn",
            "sold": "6 sold",
            "create_time": 1637748869000,
            "salePrice": "RM6.00",
            "price": "",
            "product_id": 34,
            "place": "Selangor",
            "title": "Jasmine Tea (茉莉花茶）50G-RM6.00 (FUNCTION ????????) flowers TeaLocal SellerCOD",
            "url": "https://my.xiapibuy.com//Jasmine-Tea-(茉莉花茶）50G-RM6.00-(FUNCTION-????????)-flowers-Tea-i.139760977.2287225897?sp_atk=4e27779f-3662-4fe5-a9d1-16cdbbb645bb",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/605fd96b57057eb74259ebf0e4aac3fd_tn",
            "sold": "15.1k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.48 - RM0.59",
            "price": "",
            "product_id": 98,
            "place": "Perak",
            "title": "【Ready Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶 (Hot-selling Chinese tea with strong flavor: Tieguanyin etc）ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【Ready-Stock，现货】茶叶中国浓香型热卖茶叶：铁观音，龙井茶，普洱茶，茉莉花茶，高山绿茶，大红袍茶，黑乌龙茶-(Hot-selling-Chinese-tea-with-strong-flavor-Tieguanyin-etc）-i.171504495.9139346773?sp_atk=ec19ab6c-3e4b-4f03-b3ce-2d2c1f793274",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/371c0fe6f8d9acd8622bbaf375511a89_tn",
            "sold": "264 sold",
            "create_time": 1637748869000,
            "salePrice": "RM61.88 - RM302.64",
            "price": "",
            "product_id": 62,
            "place": "Johor",
            "title": "【大红袍】武夷山正岩顶级大红袍茶 50克罐装 礼盒装 精选大红袍 高山乌龙茶 精美罐装 送礼佳品 绝对耐泡 Premium Da Hong Pao Wuyi Rock Tea 50gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【大红袍】武夷山正岩顶级大红袍茶-50克罐装-礼盒装-精选大红袍-高山乌龙茶-精美罐装-送礼佳品-绝对耐泡-Premium-Da-Hong-Pao-Wuyi-Rock-Tea-50g-i.305390642.3552510858?sp_atk=834af9db-f15b-42ac-a350-8fc700e02ec5",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/417397d3ed218a9321ef0378aa325e0e_tn",
            "sold": "71 sold",
            "create_time": 1637748869000,
            "salePrice": "RM19.88",
            "price": "",
            "product_id": 120,
            "place": "Selangor",
            "title": "Da Hong Pao Tea(Oolong Tea)  a pack 200g 乌龙茶武夷岩茶大红袍ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Da-Hong-Pao-Tea(Oolong-Tea)-a-pack-200g-乌龙茶武夷岩茶大红袍-i.155958055.3917306360?sp_atk=52cacfa0-688a-4cb1-8aed-67fce6b4bfc4",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/cfb45424f15a59c6f38a5baa7f87a82a_tn",
            "sold": "7 sold",
            "create_time": 1637748869000,
            "salePrice": "RM27.50 - RM53.10",
            "price": "",
            "product_id": 122,
            "place": "Mainland China",
            "title": "金骏眉正山小种250g/500g茶叶红茶Jinjunmei Zhengshan Race 250g/500g Tea Black TeaRM2 offCOD",
            "url": "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-i.513884826.11930571021?sp_atk=aced34d9-206e-4ee3-9f5f-d2584a16b892",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/f84190775de272992f5a667002af4c8b_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM40.00 - RM67.00",
            "price": "",
            "product_id": 155,
            "place": "Mainland China",
            "title": "【 Zhengshan race 】 super stomach nourishing black tea authentic Luzhou flavor bu�【正山小种】特级养胃红茶正宗浓香型散装高山茶叶新茶散装袋装jiumei10.my21.10.31RM5 off",
            "url": "https://my.xiapibuy.com//【-Zhengshan-race-】-super-stomach-nourishing-black-tea-authentic-Luzhou-flavor-bu�【正山小种】特级养胃红茶正宗浓香型散装高山茶叶新茶散装袋装jiumei10.my21.10.31-i.427603284.12940481775?sp_atk=6b940afc-a66d-4abc-b2c3-f5405e52de65",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/1999bd3a73986d42d9ab5977778cdf8d_tn",
            "sold": "27 sold",
            "create_time": 1637748869000,
            "salePrice": "RM45.00",
            "price": "RM50.00",
            "product_id": 85,
            "place": "Selangor",
            "title": "岩骨花香大红袍 Yan Gu Hua Xiang Da Hong Pao 【25packs x 10g】|【 武夷岩茶 Wu Yi Rock Tea 】乌龙茶 Oolong tea | Teh Cina 中国茶叶 Chinese TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//岩骨花香大红袍-Yan-Gu-Hua-Xiang-Da-Hong-Pao-【25packs-x-10g】-【-武夷岩茶-Wu-Yi-Rock-Tea-】乌龙茶-Oolong-tea-Teh-Cina-中国茶叶-Chinese-Tea-i.142200712.4154270551?sp_atk=081b14e7-298f-4b3d-a9c4-1c802e871431",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/4829bf1aa08e9ccd18caa1fa0e1ed939_tn",
            "sold": "165 sold",
            "create_time": 1637748869000,
            "salePrice": "RM30.00",
            "price": "",
            "product_id": 48,
            "place": "Selangor",
            "title": "茉莉花茶 9501 Jasmine Tea 9501 【1kg】|【花茶 Scented tea】 Chinese Tea  中国茶叶 Jasmine Green tea 香片 Teh Cina 中国茶  茶叶  茶 茉莉花ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茉莉花茶-9501-Jasmine-Tea-9501-【1kg】-【花茶-Scented-tea】-Chinese-Tea-中国茶叶-Jasmine-Green-tea-香片-Teh-Cina-中国茶-茶叶-茶-茉莉花-i.142200712.4915652376?sp_atk=51565d9d-65b8-4c3f-a850-22f675ba62eb",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/c6ac6bd7f3863efac41ab32e1e9b4882_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM15.84 - RM47.36",
            "price": "",
            "product_id": 79,
            "place": "Melaka",
            "title": "Ye Song Tea Black Tea Lapsang Souchong J叶颂茶叶 红茶正山小种金骏眉 大红袍 铁观音多款任选 礼盒装新茶lrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Ye-Song-Tea-Black-Tea-Lapsang-Souchong-J叶颂茶叶-红茶正山小种金骏眉-大红袍-铁观音多款任选-礼盒装新茶lrw3f3ycn7-i.431042679.13004573231?sp_atk=59edca51-6229-4fb9-a3e9-65152ad315c6",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/dbe9ce38639734cc39ca5946c1629a60_tn",
            "sold": "821 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.99",
            "price": "RM1.45",
            "product_id": 55,
            "place": "Kuala Lumpur",
            "title": "茉莉花茶袋装2020新茶浓香型特级毛尖  茉莉花茶小包装茶一包 jasmine teaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茉莉花茶袋装2020新茶浓香型特级毛尖-茉莉花茶小包装茶一包-jasmine-tea-i.10534598.4574525715?sp_atk=2db2e89c-da83-4a2e-b8be-5c29403f677f",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/6678fb9d28740629583b2f1f09225754_tn",
            "sold": "2 sold",
            "create_time": 1637748869000,
            "salePrice": "RM28.00 - RM58.50",
            "price": "",
            "product_id": 133,
            "place": "Mainland China",
            "title": "金骏眉正山小种250g/500g茶叶红茶礼盒装浓香型Jinjunmei Zhengshan Race 250g/500g Tea Black Tea Gift Box Luzhou-flavorRM2 offCOD",
            "url": "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶礼盒装浓香型Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-Gift-Box-Luzhou-flavor-i.513884826.11830571124?sp_atk=ba28e260-19cf-4cd2-9e5a-30141bbd5b2d",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/07ba9873b778611fc0de3219cb4350c9_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM18.25 - RM71.89",
            "price": "",
            "product_id": 175,
            "place": "Labuan",
            "title": "flavor made milk tea leaves in loose bags正山小种新茶正宗红茶武夷暖胃2021新茶浓香型做奶茶叶散袋装1b3gp6shph9.23Local SellerCOD",
            "url": "https://my.xiapibuy.com//flavor-made-milk-tea-leaves-in-loose-bags正山小种新茶正宗红茶武夷暖胃2021新茶浓香型做奶茶叶散袋装1b3gp6shph9.23-i.431087996.13214917188?sp_atk=44baddf4-68f3-4640-85fb-97a9bec3b0c6",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/9cab3e881c7499a4c173153a657e254d_tn",
            "sold": "4 sold",
            "create_time": 1637748869000,
            "salePrice": "RM34.60",
            "price": "RM86.65",
            "product_id": 139,
            "place": "Mainland China",
            "title": "【品茶】十大名茶组合套装 白茶 红茶 金骏眉 正山小种 龙井 铁观音 肉桂 茉莉花茶 黑乌龙茶 大红袍 Top Ten Famous Tea Combination Set White Tea Black Tea Jinjunmei Zhengshan Race Longjing Tieguanyin Cinnamon Jasmine Tea Black Oolong Tea Dahongpao.RM2 offCOD",
            "url": "https://my.xiapibuy.com//【品茶】十大名茶组合套装-白茶-红茶-金骏眉-正山小种-龙井-铁观音-肉桂-茉莉花茶-黑乌龙茶-大红袍-Top-Ten-Famous-Tea-Combination-Set-White-Tea-Black-Tea-Jinjunmei-Zhengshan-Race-Longjing-Tieguanyin-Cinnamon-Jasmine-Tea-Black-Oolong-Tea-Dahongpao.-i.513884826.10046177133?sp_at",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/7231b6ab83defc316bbf5d64d6661e7f_tn",
            "sold": "2.6k sold",
            "create_time": 1637748869000,
            "salePrice": "RM50.00",
            "price": "RM75.00",
            "product_id": 72,
            "place": "Selangor",
            "title": "中国茶叶 Chinese tea Teh 【100g x 3】 绿茶 大红袍 普洱 铁观音 黄金桂 水仙 乌龙茶 茉莉花茶 红茶 Puer Tea Green tea Black tea Jasmine Tea Tie guan yinShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//中国茶叶-Chinese-tea-Teh-【100g-x-3】-绿茶-大红袍-普洱-铁观音-黄金桂-水仙-乌龙茶-茉莉花茶-红茶-Puer-Tea-Green-tea-Black-tea-Jasmine-Tea-Tie-guan-yin-i.142200712.7006322272?sp_atk=c5943745-f7d9-41c8-9469-a0d4e279dfce",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/135ab7bf756aae97351c3c7db1f17ed7_tn",
            "sold": "1 sold",
            "create_time": 1637748869000,
            "salePrice": "RM16.00 - RM30.00",
            "price": "",
            "product_id": 23,
            "place": "Kuala Lumpur",
            "title": "【翟潇闻同款】fnf 原萃茶饮 冷泡果茶 浓缩液 Fruit Tea 柠檬红茶 蜜桃乌龙茶 葡萄茉莉花茶 西柚茉莉花茶 百香果乌龙茶 Passion fruit Oolong tea Grapefruit Jasmine tea Grape24% offShopMalaysia",
            "url": "https://my.xiapibuy.com//【翟潇闻同款】fnf-原萃茶饮-冷泡果茶-浓缩液-Fruit-Tea-柠檬红茶-蜜桃乌龙茶-葡萄茉莉花茶-西柚茉莉花茶-百香果乌龙茶-Passion-fruit-Oolong-tea-Grapefruit-Jasmine-tea-Grape-i.456306598.13531574732?sp_atk=d124e7c2-041a-4942-8644-1807ef9e466c",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/c71fd2092269f39679125e7b6197609c_tn",
            "sold": "395 sold",
            "create_time": 1637748869000,
            "salePrice": "RM7.80 - RM7.95",
            "price": "",
            "product_id": 14,
            "place": "Selangor",
            "title": "Ready Stock☕️Healthy Flower Fruit Tea Can  Oolong Tea Peach Tea Lemon Tea 桂圆红枣枸杞茶蜜桃乌龙茶茉莉花茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Ready-Stock☕️Healthy-Flower-Fruit-Tea-Can-Oolong-Tea-Peach-Tea-Lemon-Tea-桂圆红枣枸杞茶蜜桃乌龙茶茉莉花茶-i.11045591.4679792991?sp_atk=f7e33ac6-127d-42f6-bc62-214e6298a0a8",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/c573b49ae824ec969b6dc056543d53f0_tn",
            "sold": "15.8k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.48 - RM0.85",
            "price": "",
            "product_id": 82,
            "place": "Kuala Lumpur",
            "title": "????现货????优惠价 散装中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 金丝皇菊 菊花茶 茶叶 Chinese Tea Da Hong Pao Tie Guan Yin Pu erShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//????现货????优惠价-散装中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-金丝皇菊-菊花茶-茶叶-Chinese-Tea-Da-Hong-Pao-Tie-Guan-Yin-Pu-er-i.128031579.11920308453?sp_atk=eab1ece7-19f7-4a98-a926-a7aa06e25d74",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/79794e1496508c29c51788d335d02943_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM32.00 - RM110.00",
            "price": "",
            "product_id": 146,
            "place": "Mainland China",
            "title": "Xincha Zhengshan seed bulk red tea Luzhou flavor seed bagged 500g manufacturer w�新茶正山小种散装红茶叶浓香型小种袋装500克厂家批发口粮茶便宜jiumei10.my21.10.31RM5 off",
            "url": "https://my.xiapibuy.com//Xincha-Zhengshan-seed-bulk-red-tea-Luzhou-flavor-seed-bagged-500g-manufacturer-w�新茶正山小种散装红茶叶浓香型小种袋装500克厂家批发口粮茶便宜jiumei10.my21.10.31-i.427603284.13940465849?sp_atk=7fe4b7be-a528-41d7-ae60-d03639f3b748",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/73d07c490e781ea19afd3f8f42f74522_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM2.98",
            "price": "RM3.90",
            "product_id": 9,
            "place": "Selangor",
            "title": "农夫山泉 茶兀果茶 茶兀 茶派  柚子绿茶/蜜桃乌龙茶/柠檬红茶/西柚茉莉花茶 500ml Nongfu Spring Cha Pai Fruit TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//农夫山泉-茶兀果茶-茶兀-茶派-柚子绿茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-500ml-Nongfu-Spring-Cha-Pai-Fruit-Tea-i.286624696.13152589206?sp_atk=11abaedb-7cc6-45ad-958e-4cd7df6676c8",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/a1f2d60b23470a3feae3cd3f6622f32f_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM116.20",
            "price": "RM290.69",
            "product_id": 118,
            "place": "Mainland China",
            "title": "【大红袍】正宗武夷山 源产地发货 浓香型 乌龙茶 武夷岩茶 铁罐装250g 【Dahongpao】 250g of Luzhou-flavor Oolong Tea and Wuyi Rock Tea Can Be Delivered from the Original Origin of Wuyi Mountain.RM20 offCOD",
            "url": "https://my.xiapibuy.com//【大红袍】正宗武夷山-源产地发货-浓香型-乌龙茶-武夷岩茶-铁罐装250g-【Dahongpao】-250g-of-Luzhou-flavor-Oolong-Tea-and-Wuyi-Rock-Tea-Can-Be-Delivered-from-the-Original-Origin-of-Wuyi-Mountain.-i.513884826.12631114509?sp_atk=716ba55c-f3c2-4b2b-868b-0f3ffe29af53",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/103271f05a7b2f77fc9b6bbb3287523b_tn",
            "sold": "1.9k sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.65",
            "price": "RM2.80",
            "product_id": 106,
            "place": "Penang",
            "title": "武夷高山大红袍 福建乌龙茶 浓香肉桂 Dahongpao Tea [ High Quality ]ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//武夷高山大红袍-福建乌龙茶-浓香肉桂-Dahongpao-Tea-High-Quality--i.60201032.4731718517?sp_atk=039b9c8e-5d26-4041-bd92-d1a067a8624a",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/c791a715eb0d7023107b798ed4c4761e_tn",
            "sold": "16 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.30",
            "price": "",
            "product_id": 45,
            "place": "Kuala Lumpur",
            "title": "Lipton Fruit Tea 立顿维C 冷泡果茶 速溶果汁茶粉固体饮料 白桃乌龙茶味 Peach Oolong Tea 西柚茉莉花茶 Grapefruit Jasmine Tea 半桔半柠红茶 umquat Lemon Black TeShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Lipton-Fruit-Tea-立顿维C-冷泡果茶-速溶果汁茶粉固体饮料-白桃乌龙茶味-Peach-Oolong-Tea-西柚茉莉花茶-Grapefruit-Jasmine-Tea-半桔半柠红茶-umquat-Lemon-Black-Te-i.456306598.9594816560?sp_atk=9f173894-07d6-4b24-8e33-fc9f1800a1dd",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/344fc23ca43122f2c311d8d1d816371f_tn",
            "sold": "2 sold",
            "create_time": 1637748869000,
            "salePrice": "RM33.50 - RM60.20",
            "price": "",
            "product_id": 110,
            "place": "Mainland China",
            "title": "【 武夷山大红袍】正岩岩茶 浓香型肉桂 水仙奇兰 盒装250g 【Wuyishan Dahongpao】 Zhengyan Rock Tea Luzhou-flavor Cinnamon Narcissus Chilan Boxed 250g.RM2 offCOD",
            "url": "https://my.xiapibuy.com//【-武夷山大红袍】正岩岩茶-浓香型肉桂-水仙奇兰-盒装250g-【Wuyishan-Dahongpao】-Zhengyan-Rock-Tea-Luzhou-flavor-Cinnamon-Narcissus-Chilan-Boxed-250g.-i.513884826.11859947689?sp_atk=3793280f-dda8-4770-acbe-a4a56ae1db67",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f0a5bcd77aeb52d2e8ed230f68dc55f2_tn",
            "sold": "274 sold",
            "create_time": 1637748869000,
            "salePrice": "RM13.12",
            "price": "RM15.80",
            "product_id": 80,
            "place": "Kuala Lumpur",
            "title": "大红袍 浓香型 盒装 （20小包）140g Da Hong Pao TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//大红袍-浓香型-盒装-（20小包）140g-Da-Hong-Pao-Tea-i.266929667.7460866966?sp_atk=65ce40c4-c704-49bb-9c9d-801487364db0",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/086acfa818c7f5ac7c3d5ceea157457b_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM15.99",
            "price": "RM16.50",
            "product_id": 137,
            "place": "Melaka",
            "title": "铁罐装茶叶 碧螺春 普洱茶 正山小种 金骏眉 茉莉花茶 铁观音 绿茶 大红袍 中国茶叶 #chinese tea #各类式 #名茶 #浓香ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//铁罐装茶叶-碧螺春-普洱茶-正山小种-金骏眉-茉莉花茶-铁观音-绿茶-大红袍-中国茶叶-chinese-tea-各类式-名茶-浓香-i.396483765.10770414275?sp_atk=dfe68040-e11a-4519-a4e3-775f44d6b4bd",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/cfb45424f15a59c6f38a5baa7f87a82a_tn",
            "sold": "7 sold",
            "create_time": 1637748869000,
            "salePrice": "RM27.50 - RM53.10",
            "price": "",
            "product_id": 127,
            "place": "Mainland China",
            "title": "金骏眉正山小种250g/500g茶叶红茶Jinjunmei Zhengshan Race 250g/500g Tea Black TeaRM2 offCOD",
            "url": "https://my.xiapibuy.com//金骏眉正山小种250g-500g茶叶红茶Jinjunmei-Zhengshan-Race-250g-500g-Tea-Black-Tea-i.513884826.11930571021?sp_atk=c5ea52a0-7552-4232-be4a-aa11fa756cbb",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/5e98a51bba3a920213f6b04c5f323e47_tn",
            "sold": "2.3k sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.63",
            "price": "RM5.00",
            "product_id": 37,
            "place": "Kuala Lumpur",
            "title": "FYZ Herbs Jasmine Flower Tea 30g [Value Pack] 茉莉花茶袋装 30gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//FYZ-Herbs-Jasmine-Flower-Tea-30g-Value-Pack-茉莉花茶袋装-30g-i.33209905.868838231?sp_atk=22a45ef0-a806-45b1-90c1-4503891fa5dc",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/d9f5f1374ad3dc79a513394c41f64570_tn",
            "sold": "47 sold",
            "create_time": 1637748869000,
            "salePrice": "RM10.50",
            "price": "RM10.90",
            "product_id": 4,
            "place": "Penang",
            "title": "Jasmine Tea Flower Tea 100g 浓香型茉莉花茶浓香小白豪 花茶RM1 offShopMalaysia",
            "url": "https://my.xiapibuy.com//Jasmine-Tea-Flower-Tea-100g-浓香型茉莉花茶浓香小白豪-花茶-i.60201032.8749449249?sp_atk=cdd61eac-1ddd-418a-a280-c1179e00e3bf",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/e5277481bd32fd83e3413f1ffb90438d_tn",
            "sold": "644 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.85",
            "price": "",
            "product_id": 103,
            "place": "Selangor",
            "title": "Wuyi Tea 武夷山岩茶叶（大红袍, 肉桂，水仙，奇兰）ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//Wuyi-Tea-武夷山岩茶叶（大红袍-肉桂，水仙，奇兰）-i.107485006.9860230280?sp_atk=f65ddb87-ef09-4c87-965a-581e236486d3",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f1b10da91d69981e4146bd824c2e7075_tn",
            "sold": "1 sold",
            "create_time": 1637748869000,
            "salePrice": "RM58.10",
            "price": "RM145.45",
            "product_id": 74,
            "place": "Mainland China",
            "title": "【大红袍】木桶装大红袍 正宗武夷岩茶 浓香型乌龙茶 300g茶叶 木桶礼盒装  【Dahongpao】 in wooden barrel Dahongpao authentic Wuyi rock tea Luzhou-flavor oolong tea 300g tea wooden barrel gift boxRM5 offCOD",
            "url": "https://my.xiapibuy.com//【大红袍】木桶装大红袍-正宗武夷岩茶-浓香型乌龙茶-300g茶叶-木桶礼盒装-【Dahongpao】-in-wooden-barrel-Dahongpao-authentic-Wuyi-rock-tea-Luzhou-flavor-oolong-tea-300g-tea-wooden-barrel-gift-box-i.513884826.12050019666?sp_atk=6bbcd7c9-e3b4-4c96-a8e5-c836a541d00b",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f2ca9597d39b4d0a4e64efa92ba448bd_tn",
            "sold": "35.7k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.49 - RM0.89",
            "price": "",
            "product_id": 65,
            "place": "Kedah",
            "title": "【中国茶小袋装】铁观音 大红袍 黑乌龙 普洱 5-7g Chinese TeasShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【中国茶小袋装】铁观音-大红袍-黑乌龙-普洱-5-7g-Chinese-Teas-i.15549999.9328673007?sp_atk=e34cdc44-b381-4dcc-b5e8-d4608366b2d3",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/ced977d406fc5ee2d7ac10b501a45c37_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM33.50 - RM115.50",
            "price": "",
            "product_id": 177,
            "place": "Mainland China",
            "title": "【红茶】特级正山小种茶叶 正宗武夷山新茶 浓香型养胃红茶 小包袋装PC盒  【Black Tea】 Super Zhengshan Race Tea Authentic Wuyishan New Tea Luzhou-flavor Stomach-nourishing Black Tea Packed PC Box.RM2 offCOD",
            "url": "https://my.xiapibuy.com//【红茶】特级正山小种茶叶-正宗武夷山新茶-浓香型养胃红茶-小包袋装PC盒-【Black-Tea】-Super-Zhengshan-Race-Tea-Authentic-Wuyishan-New-Tea-Luzhou-flavor-Stomach-nourishing-Black-Tea-Packed-PC-Box.-i.513884826.12542545029?sp_atk=d355eae4-fbd2-4d55-ac3c-22074ce895ef",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/371c0fe6f8d9acd8622bbaf375511a89_tn",
            "sold": "264 sold",
            "create_time": 1637748869000,
            "salePrice": "RM61.88 - RM302.64",
            "price": "",
            "product_id": 73,
            "place": "Johor",
            "title": "【大红袍】武夷山正岩顶级大红袍茶 50克罐装 礼盒装 精选大红袍 高山乌龙茶 精美罐装 送礼佳品 绝对耐泡 Premium Da Hong Pao Wuyi Rock Tea 50gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【大红袍】武夷山正岩顶级大红袍茶-50克罐装-礼盒装-精选大红袍-高山乌龙茶-精美罐装-送礼佳品-绝对耐泡-Premium-Da-Hong-Pao-Wuyi-Rock-Tea-50g-i.305390642.3552510858?sp_atk=50337424-e197-4d50-b088-5a52fbe7dcc4",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/7eded9be01cba401f343d117d525129e_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM38.00 - RM74.10",
            "price": "",
            "product_id": 145,
            "place": "Melaka",
            "title": "Tea black tea Jinjunmei Zhengshan small茶叶红茶 金骏眉正山小种茶叶250g/500g 罐装礼盒装茶叶lrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Tea-black-tea-Jinjunmei-Zhengshan-small茶叶红茶-金骏眉正山小种茶叶250g-500g-罐装礼盒装茶叶lrw3f3ycn7-i.431042679.12929854814?sp_atk=79cbc07b-e505-4860-99a1-0924f46056b8",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/5bcf7437fdcd509465c9f7c03721523e_tn",
            "sold": "5 sold",
            "create_time": 1637748869000,
            "salePrice": "RM36.80 - RM67.90",
            "price": "",
            "product_id": 89,
            "place": "Mainland China",
            "title": "红茶武夷山特级岩茶熟茶大红袍浓香型茶叶礼盒装罐装送礼新茶 Black Tea Wuyishan Super Rock Tea Cooked Tea Dahongpao Luzhou-flavor Tea Gift Box Canned Gift-giving New Tea.RM5 offCOD",
            "url": "https://my.xiapibuy.com//红茶武夷山特级岩茶熟茶大红袍浓香型茶叶礼盒装罐装送礼新茶-Black-Tea-Wuyishan-Super-Rock-Tea-Cooked-Tea-Dahongpao-Luzhou-flavor-Tea-Gift-Box-Canned-Gift-giving-New-Tea.-i.513884826.12105475755?sp_atk=84e2267c-a080-4b5d-abd9-d4a24fec1c40",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/26defe96920ac5ba06ff5b36245b5af1_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM96.84",
            "price": "",
            "product_id": 151,
            "place": "Selangor",
            "title": "Tea 送茶具金骏眉红茶养胃正宗正山小种大红袍新茶批发茶叶礼盒装250g 0923Local SellerCOD",
            "url": "https://my.xiapibuy.com//Tea-送茶具金骏眉红茶养胃正宗正山小种大红袍新茶批发茶叶礼盒装250g-0923-i.426356574.12414532334?sp_atk=b72e9508-97fb-49d7-8186-5bd20663410b",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/d03aedce405b4801c268768f7aa9246d_tn",
            "sold": "50 sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.58",
            "price": "",
            "product_id": 13,
            "place": "Melaka",
            "title": "茶叶 小袋 散装包 普洱茶 碧螺春 毛尖茶 黄金桂 铁观音 绿茶 正山小种 金丝皇菊 茉莉花茶 黑乌龙茶 大红袍 龙井 炭焙铁观音 金骏眉 中国茶叶 #浓香 #现货 #chinese tea pack #ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茶叶-小袋-散装包-普洱茶-碧螺春-毛尖茶-黄金桂-铁观音-绿茶-正山小种-金丝皇菊-茉莉花茶-黑乌龙茶-大红袍-龙井-炭焙铁观音-金骏眉-中国茶叶-浓香-现货-chinese-tea-pack--i.396483765.12247654293?sp_atk=31a9ab92-4e73-499b-a641-bca3f9e85bd0",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/0bebf290d438cf85ff6a382255f73040_tn",
            "sold": "18 sold",
            "create_time": 1637748869000,
            "salePrice": "RM9.90 - RM32.50",
            "price": "",
            "product_id": 77,
            "place": "Mainland China",
            "title": "新茶浓香大红袍茶叶罐装岩茶肉桂水仙乌龙茶New Tea Fragrant Dahongpao Tea Canned Rock Tea Cinnamon Narcissus Oolong TeaCODAdd-on Deal",
            "url": "https://my.xiapibuy.com//新茶浓香大红袍茶叶罐装岩茶肉桂水仙乌龙茶New-Tea-Fragrant-Dahongpao-Tea-Canned-Rock-Tea-Cinnamon-Narcissus-Oolong-Tea-i.513884826.10730567114?sp_atk=013f40df-a2bf-4dbd-b488-74ab202b04d3",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f07f03d8d5e404a423fcb0a7389a82f8_tn",
            "sold": "118 sold",
            "create_time": 1637748869000,
            "salePrice": "RM8.90",
            "price": "RM9.50",
            "product_id": 78,
            "place": "Kuala Lumpur",
            "title": "????现货????精美铁盒+单独包装 中国茶 大红袍 铁观音 普洱熟茶 黑乌龙 龙井茶 小种红茶 茉莉花茶 高山绿茶 炭焙铁观音 碧螺春 金俊眉 Chinese Tea Da Hong Pao Puer Tie Guan YinShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//????现货????精美铁盒-单独包装-中国茶-大红袍-铁观音-普洱熟茶-黑乌龙-龙井茶-小种红茶-茉莉花茶-高山绿茶-炭焙铁观音-碧螺春-金俊眉-Chinese-Tea-Da-Hong-Pao-Puer-Tie-Guan-Yin-i.128031579.12917419602?sp_atk=168b3483-9b28-4c67-a2d6-71ce5ffa2128",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/8c18b0cafb0ee0b9260b3a99e5330631_tn",
            "sold": "7 sold",
            "create_time": 1637748869000,
            "salePrice": "RM23.75 - RM47.50",
            "price": "",
            "product_id": 17,
            "place": "Selangor",
            "title": "????????????High Quality Jasmine Tea Chinese Tea Kobicha Tea 茉莉花茶 中国名茶 媚茶RM2 offShopMalaysia",
            "url": "https://my.xiapibuy.com//????????????High-Quality-Jasmine-Tea-Chinese-Tea-Kobicha-Tea-茉莉花茶-中国名茶-媚茶-i.255098748.8190269696?sp_atk=45a8b650-5da4-4b17-b79c-e269ef33178a",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/7231b6ab83defc316bbf5d64d6661e7f_tn",
            "sold": "2.6k sold",
            "create_time": 1637748869000,
            "salePrice": "RM50.00",
            "price": "RM75.00",
            "product_id": 26,
            "place": "Selangor",
            "title": "中国茶叶 Chinese tea Teh 【100g x 3】 绿茶 大红袍 普洱 铁观音 黄金桂 水仙 乌龙茶 茉莉花茶 红茶 Puer Tea Green tea Black tea Jasmine Tea Tie guan yinShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//中国茶叶-Chinese-tea-Teh-【100g-x-3】-绿茶-大红袍-普洱-铁观音-黄金桂-水仙-乌龙茶-茉莉花茶-红茶-Puer-Tea-Green-tea-Black-tea-Jasmine-Tea-Tie-guan-yin-i.142200712.7006322272?sp_atk=d1745805-d224-4c41-8929-f45a1f2578e3",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/e0ebe2a6973fe85a40f7ff30e6936f80_tn",
            "sold": "198.6k sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.85",
            "price": "RM2.90",
            "product_id": 7,
            "place": "Selangor",
            "title": "农夫山泉茶兀果茶 系列 Nongfu Spring Cha Pai Fruit Tea 250ml/500ml 茶派 蜜桃乌龙茶/柚子绿茶/柠檬红茶/西柚茉莉花茶Local SellerCOD",
            "url": "https://my.xiapibuy.com//农夫山泉茶兀果茶-系列-Nongfu-Spring-Cha-Pai-Fruit-Tea-250ml-500ml-茶派-蜜桃乌龙茶-柚子绿茶-柠檬红茶-西柚茉莉花茶-i.323100044.6167004355?sp_atk=5ca05917-b716-4aa7-85fe-35880147e503",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/4f4cb5b8c6505eb4d513456e26b9536b_tn",
            "sold": "162 sold",
            "create_time": 1637748869000,
            "salePrice": "RM15.88 - RM18.88",
            "price": "",
            "product_id": 132,
            "place": "Selangor",
            "title": "普洱茶 金骏眉 正山小种 大红袍 铁观音 茉莉花茶 高山绿茶 碧螺春 黄金桂茶 黑乌龙茶 龙景绿茶 毛尖 炭焙铁观音 奇兰 老叢水仙 肉桂 凤凰單叢 茶叶 chinese tea health Puer Da Hong Pao OolongShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//普洱茶-金骏眉-正山小种-大红袍-铁观音-茉莉花茶-高山绿茶-碧螺春-黄金桂茶-黑乌龙茶-龙景绿茶-毛尖-炭焙铁观音-奇兰-老叢水仙-肉桂-凤凰單叢-茶叶-chinese-tea-health-Puer-Da-Hong-Pao-Oolong-i.653343.9513923540?sp_atk=0197bc46-d343-438f-a4b2-2b335893a6ff",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/06fc59a4a0bf919f3feee2f4976a1c23_tn",
            "sold": "3 sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.90",
            "price": "",
            "product_id": 35,
            "place": "Selangor",
            "title": "农夫山泉东方树叶红茶茉莉花茶乌龙茶绿茶无糖乌龙茶饮料Black Tea/Jasmine Tea/Oolong Tea/Green TeaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//农夫山泉东方树叶红茶茉莉花茶乌龙茶绿茶无糖乌龙茶饮料Black-Tea-Jasmine-Tea-Oolong-Tea-Green-Tea-i.43656429.11541399688?sp_atk=ccc5dcce-0791-487f-ab3f-f7ac70a3aada",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/77a0c44a396309ed01db07adabd9a40b_tn",
            "sold": "69 sold",
            "create_time": 1637748869000,
            "salePrice": "RM5.19",
            "price": "RM8.30",
            "product_id": 88,
            "place": "Penang",
            "title": "大红袍 火锅底料 麻辣 三鲜 清油火锅 红汤火锅 Steamboat Soup Base MaLaTang/ CleaorOil/ RedSoup/ ThreeDelicacies150g-168gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//大红袍-火锅底料-麻辣-三鲜-清油火锅-红汤火锅-Steamboat-Soup-Base-MaLaTang-CleaorOil-RedSoup-ThreeDelicacies150g-168g-i.67632715.13110305442?sp_atk=eaf7b906-9e00-45a0-b761-d9b8fd2b1bb9",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/3e5156546dc9ab257b8f5eabe04a2255_tn",
            "sold": "20 sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.50 - RM3.50",
            "price": "",
            "product_id": 71,
            "place": "Penang",
            "title": "大红袍茶叶创意随手礼盒牛皮纸简易通用折叠单双提Dahongpao tea creative handy gift box kraft paper simple universal folding single and double liftShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//大红袍茶叶创意随手礼盒牛皮纸简易通用折叠单双提Dahongpao-tea-creative-handy-gift-box-kraft-paper-simple-universal-folding-single-and-double-lift-i.24094122.13352334674?sp_atk=6091d2f0-e4c6-47bf-8329-d2b596094d39",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/7f9c5f25c7a38066c877a793973f84cd_tn",
            "sold": "1 sold",
            "create_time": 1637748869000,
            "salePrice": "RM12.10 - RM50.16",
            "price": "",
            "product_id": 11,
            "place": "Melaka",
            "title": "Jasmine tea 2021 new tea jasmine tea jas茉莉花茶 茶叶 2021新茶茉莉花茶叶茉莉花茶袋装罐装250g500g125glrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Jasmine-tea-2021-new-tea-jasmine-tea-jas茉莉花茶-茶叶-2021新茶茉莉花茶叶茉莉花茶袋装罐装250g500g125glrw3f3ycn7-i.431042679.12229854320?sp_atk=643330f3-d3f0-4813-82e0-ee990ae6db8f",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/57d7a2ec7129eb4a79da5438d3606fb4_tn",
            "sold": "541 sold",
            "create_time": 1637748869000,
            "salePrice": "RM17.10",
            "price": "RM24.42",
            "product_id": 113,
            "place": "Kuala Lumpur",
            "title": "大红袍茶叶 武夷岩茶 试喝装 奇兰 水仙 肉桂 矮脚乌龙茶 浓香型16口味128g Assorted tea 16 flavorsShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//大红袍茶叶-武夷岩茶-试喝装-奇兰-水仙-肉桂-矮脚乌龙茶-浓香型16口味128g-Assorted-tea-16-flavors-i.266929667.4162348297?sp_atk=f2a6630d-15c8-4fe3-b1f5-60a79258f68e",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/b213ca24a3ad0ebba19b92ce02bcd1f8_tn",
            "sold": "186 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.98",
            "price": "RM5.88",
            "product_id": 28,
            "place": "Kuala Lumpur",
            "title": "【九零食代】农夫山泉 茶兀 茶π 茶派 网红爆款 饮料 Nongfu Spring Cha Pai Fruit Tea 500ml 蜜桃乌龙茶 / 柚子绿茶 / 柠檬红茶 / 西柚茉莉花茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【九零食代】农夫山泉-茶兀-茶π-茶派-网红爆款-饮料-Nongfu-Spring-Cha-Pai-Fruit-Tea-500ml-蜜桃乌龙茶-柚子绿茶-柠檬红茶-西柚茉莉花茶-i.535543179.11548199571?sp_atk=c142ff93-0555-4b2f-903c-d1f4b8177507",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/3509cce1ebb8530c379ca17640cf2147_tn",
            "sold": "68k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.27 - RM0.95",
            "price": "",
            "product_id": 56,
            "place": "Perak",
            "title": "【COH】花茶 花茶包 Flower tea | Teh Bunga【壹间草药】无糖 No sugar Sugar free Tea 茶包 花茶 养生茶 Beauty 排毒 养生花茶 玫瑰 Rose Jasmine Tea bagShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【COH】花茶-花茶包-Flower-tea-Teh-Bunga【壹间草药】无糖-No-sugar-Sugar-free-Tea-茶包-花茶-养生茶-Beauty-排毒-养生花茶-玫瑰-Rose-Jasmine-Tea-bag-i.26353660.10807019469?sp_atk=c261e8db-e41c-4be5-af4a-60fc99a7bf25",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/68906710acf7f0187e967116cc88ace5_tn",
            "sold": "17 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.59",
            "price": "",
            "product_id": 3,
            "place": "Johor",
            "title": "农夫山泉 茶兀 茶派 柚子绿茶 玫瑰荔枝红茶 蜜桃乌龙茶 柠檬红茶 西柚茉莉花茶 500ml NongFu Spring Fruit Tea 500mShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//农夫山泉-茶兀-茶派-柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶-500ml-NongFu-Spring-Fruit-Tea-500m-i.277296017.14301040296?sp_atk=f8a4760c-a069-4fcd-a10a-12633ff813d6",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/3b495fce46d45b283f906962fc0780a2_tn",
            "sold": "595 sold",
            "create_time": 1637748869000,
            "salePrice": "RM25.00",
            "price": "",
            "product_id": 95,
            "place": "Selangor",
            "title": "岩骨花香大红袍 Yan Gu Hua Xiang Da Hong Pao 【100g】|【 武夷岩茶 Wu Yi Rock Tea 】 Oolong tea Teh Cina  中国茶叶 Chinese Tea 中国茶  茶叶  茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//岩骨花香大红袍-Yan-Gu-Hua-Xiang-Da-Hong-Pao-【100g】-【-武夷岩茶-Wu-Yi-Rock-Tea-】-Oolong-tea-Teh-Cina-中国茶叶-Chinese-Tea-中国茶-茶叶-茶-i.142200712.6442200049?sp_atk=68b6193d-fde8-49d4-a744-46ac22baf04e",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/719dbf2663f019a654a3458c82428ce2_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM20.80 - RM67.20",
            "price": "",
            "product_id": 160,
            "place": "Melaka",
            "title": "Inheritor tea black tea new tea Jinjun M传承者茶叶红茶 新茶金骏眉正山小种浓香耐泡养胃罐装礼盒装lrw3f3ycn7Local SellerCOD",
            "url": "https://my.xiapibuy.com//Inheritor-tea-black-tea-new-tea-Jinjun-M传承者茶叶红茶-新茶金骏眉正山小种浓香耐泡养胃罐装礼盒装lrw3f3ycn7-i.431042679.13203963992?sp_atk=2079661d-1c14-4653-baa2-298042c40eec",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/d5956e3bfc1ee67635b471d3c2e45528_tn",
            "sold": "32k sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.85 - RM2.89",
            "price": "",
            "product_id": 58,
            "place": "Selangor",
            "title": "农夫山泉茶π Nongfu Spring Cha Pai Cha Pie 茶π 茶派 Fruit Tea 500mlShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//农夫山泉茶π-Nongfu-Spring-Cha-Pai-Cha-Pie-茶π-茶派-Fruit-Tea-500ml-i.239158017.5722151393?sp_atk=9f90d48a-2854-4189-9a82-298da32a058e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/1e24be0b8b56ad6338ab2e04be5473b3_tn",
            "sold": "6 sold",
            "create_time": 1637748869000,
            "salePrice": "RM9.90",
            "price": "",
            "product_id": 169,
            "place": "Johor",
            "title": "[Mk] Chinese Tea 茶叶 中国茶 铁观音 大红袍 黑乌龙茶 普洱熟茶 正山小种 龙井 皇菊 茉莉花茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//-Mk-Chinese-Tea-茶叶-中国茶-铁观音-大红袍-黑乌龙茶-普洱熟茶-正山小种-龙井-皇菊-茉莉花茶-i.67430736.10952763072?sp_atk=04977abc-d950-4c2b-9571-2ed75da2c046",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/20a5602194fedf81de8f21ef1a5b6d78_tn",
            "sold": "561 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.95",
            "price": "RM5.00",
            "product_id": 30,
            "place": "Kuala Lumpur",
            "title": "【SALES????】农夫山泉 茶兀 茶派 (柚子绿茶 / 玫瑰荔枝红茶 / 蜜桃乌龙茶 / 柠檬红茶 / 西柚茉莉花茶) NongFu Spring Fruit Tea Cha Pai500mlShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【SALES????】农夫山泉-茶兀-茶派-(柚子绿茶-玫瑰荔枝红茶-蜜桃乌龙茶-柠檬红茶-西柚茉莉花茶)-NongFu-Spring-Fruit-Tea-Cha-Pai500ml-i.61764449.13808918658?sp_atk=0c12a257-3d2c-4bf4-8b4e-308cfb59936d",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/2b01dccb7ec5eee9249e5f51fa587c77_tn",
            "sold": "64 sold",
            "create_time": 1637748869000,
            "salePrice": "RM2.50",
            "price": "",
            "product_id": 16,
            "place": "Sarawak",
            "title": "香喷喷的茉莉花茶   Jasmine Tea☜100gShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//香喷喷的茉莉花茶-Jasmine-Tea☜100g-i.69282524.5739976485?sp_atk=0344ec89-9e20-4552-94b2-4e2418c013d3",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/4a50fd5845ac45d96d38d7fa675a1b36_tn",
            "sold": "76 sold",
            "create_time": 1637748869000,
            "salePrice": "RM3.31 - RM7.56",
            "price": "",
            "product_id": 49,
            "place": "Selangor",
            "title": "[High Quality] Natural Dried Jasmine Buds Flower Herbal Tea 茉莉散装花茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//-High-Quality-Natural-Dried-Jasmine-Buds-Flower-Herbal-Tea-茉莉散装花茶-i.80434172.3666492158?sp_atk=489256d4-aeb4-4331-ab71-4c96aa1a8141",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/c9710025c5c0828ef779038cd79b031b_tn",
            "sold": "595 sold",
            "create_time": 1637748869000,
            "salePrice": "RM25.00",
            "price": "",
            "product_id": 42,
            "place": "Selangor",
            "title": "茉莉花茶 Jasmine Tea 【100g】 |【花茶 Scented tea】 Chinese Tea 中国茶叶 Teh Cina 中国茶  茶叶  茶ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茉莉花茶-Jasmine-Tea-【100g】-【花茶-Scented-tea】-Chinese-Tea-中国茶叶-Teh-Cina-中国茶-茶叶-茶-i.142200712.4504541855?sp_atk=0f2a9c90-2871-4b95-95ae-b2fe81a64bd6",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/f30bd01cfa39ca1f121e807718144767_tn",
            "sold": "3.3k sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.01",
            "price": "RM5.00",
            "product_id": 61,
            "place": "Negeri Sembilan",
            "title": "武夷山大红袍 5g 中国茶 Dahongpao Tea 1 pack 5g(26 packs=1box)ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//武夷山大红袍-5g-中国茶-Dahongpao-Tea-1-pack-5g(26-packs-1box)-i.26435989.4967239930?sp_atk=401cbd99-b1ad-4d93-852c-b3c23ff59a12",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "大红袍",
            "image": "https://cf.shopee.com.my/file/5f8439936804e7040b6b6963a62d4185_tn",
            "sold": "4.9k sold",
            "create_time": 1637748869000,
            "salePrice": "RM0.45",
            "price": "RM2.00",
            "product_id": 63,
            "place": "Kuala Lumpur",
            "title": "{READY STOCK}{中国茶小袋装} 大红袍 铁观音 金骏眉 黑乌龙 普洱茶 6-8g Individual Pack Chinese Tea Tie Guan Yin Da Hong Pao Jasmine Tea Teh CinaShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//-READY-STOCK-中国茶小袋装-大红袍-铁观音-金骏眉-黑乌龙-普洱茶-6-8g-Individual-Pack-Chinese-Tea-Tie-Guan-Yin-Da-Hong-Pao-Jasmine-Tea-Teh-Cina-i.421424331.6297246712?sp_atk=efa98aab-28ba-46d5-af54-04b320e97c8c",
            "labels": [],
            "sku": "TEA784584123"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/ea87a6fd19552a8cd2b0f683af7aab7f_tn",
            "sold": "31 sold",
            "create_time": 1637748869000,
            "salePrice": "RM5.20",
            "price": "",
            "product_id": 50,
            "place": "Selangor",
            "title": "【花茶 Flower Tea】Loherbs 茉莉花茶 Dried Jasmine Flower Tea 50Gram / Bunga Jasmine Kering/ Bunga Melati KeringShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//【花茶-Flower-Tea】Loherbs-茉莉花茶-Dried-Jasmine-Flower-Tea-50Gram-Bunga-Jasmine-Kering-Bunga-Melati-Kering-i.16878056.13702335089?sp_atk=a05c72c8-cf34-401c-bb81-3ebb876fe8eb",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/e73eda431ba159412e62972de2e0834d_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM11.00 - RM14.00",
            "price": "",
            "product_id": 15,
            "place": "Selangor",
            "title": "精美铁罐 三角茶包 水果 花茶 Healthy Flower Fruit Tea Can 蜜桃乌龙茶 蔓越莓 茉莉 玄米绿茶 冬瓜荷叶茶 Japanese Jasmine Green Tea Peach Oolong CranberryShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//精美铁罐-三角茶包-水果-花茶-Healthy-Flower-Fruit-Tea-Can-蜜桃乌龙茶-蔓越莓-茉莉-玄米绿茶-冬瓜荷叶茶-Japanese-Jasmine-Green-Tea-Peach-Oolong-Cranberry-i.9084405.13817598112?sp_atk=b0221ea2-dd61-41c2-8202-eaa736fb610e",
            "labels": [],
            "sku": "TEA514521548"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/667f60cbbf9107000d99fc687bf04e50_tn",
            "sold": "",
            "create_time": 1637748869000,
            "salePrice": "RM94.80 - RM117.45",
            "price": "",
            "product_id": 156,
            "place": "Selangor",
            "title": "Tea 过节送礼 武夷山大红袍高档礼盒 正山小种金骏眉茶叶特级红茶500g 0923Local SellerCOD",
            "url": "https://my.xiapibuy.com//Tea-过节送礼-武夷山大红袍高档礼盒-正山小种金骏眉茶叶特级红茶500g-0923-i.426356574.13914512147?sp_atk=6591c703-517f-4b5f-8066-d6dde5446a9b",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "正山小种",
            "image": "https://cf.shopee.com.my/file/547b28a3dd8a4f482af72d07575c6c17_tn",
            "sold": "86 sold",
            "create_time": 1637748869000,
            "salePrice": "RM1.30",
            "price": "",
            "product_id": 158,
            "place": "Perak",
            "title": "正山小种 5g 红茶 Red Tea 1packShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//正山小种-5g-红茶-Red-Tea-1pack-i.32606391.6264410670?sp_atk=2d278b90-8d42-4d12-90b2-d618e1fe1f9b",
            "labels": [],
            "sku": "TEA474528754"
          }, {
            "country": "马来西亚",
            "tea": "茉莉花",
            "image": "https://cf.shopee.com.my/file/00099179b17f2eeab6161a2a0a15f47b_tn",
            "sold": "648 sold",
            "create_time": 1637748869000,
            "salePrice": "RM20.00",
            "price": "",
            "product_id": 6,
            "place": "Selangor",
            "title": "茉莉花茶 9601 Jasmine Tea 9601 【1kg】|【花茶 Scented tea】 Chinese Tea  中国茶叶 Jasmine Green tea 香片 Teh Cina 中国茶  茶叶  茶 茉莉花ShopMalaysiaLocal Seller",
            "url": "https://my.xiapibuy.com//茉莉花茶-9601-Jasmine-Tea-9601-【1kg】-【花茶-Scented-tea】-Chinese-Tea-中国茶叶-Jasmine-Green-tea-香片-Teh-Cina-中国茶-茶叶-茶-茉莉花-i.142200712.4315652146?sp_atk=a38aa087-f6c8-428a-910b-9789d2866fa0",
            "labels": [],
            "sku": "TEA514521548"
          }],
        tableFilter: [],
        pagination: {
          total: 0,
          currentPage: 1
        },
        originData: {
          total: [{"price": 0, "molihua": 0, "zhengshanxiaozhong": 0, "dahongpao": 0}, {
            "price": 1,
            "molihua": 0,
            "zhengshanxiaozhong": 0,
            "dahongpao": 0
          }, {"price": 2, "molihua": 154, "zhengshanxiaozhong": 182.5, "dahongpao": 231.3}, {
            "price": 3,
            "molihua": 30761,
            "zhengshanxiaozhong": 27131,
            "dahongpao": 31896.4
          }, {"price": 4, "molihua": 35262, "zhengshanxiaozhong": 31416.5, "dahongpao": 36815.5}, {
            "price": 5,
            "molihua": 40253,
            "zhengshanxiaozhong": 34090,
            "dahongpao": 40463.6
          }, {"price": 6, "molihua": 452464, "zhengshanxiaozhong": 367787.5, "dahongpao": 447453.7}, {
            "price": 7,
            "molihua": 502365,
            "zhengshanxiaozhong": 394673,
            "dahongpao": 490272.8
          }, {"price": 8, "molihua": 552266, "zhengshanxiaozhong": 421558.5, "dahongpao": 533091.9}, {
            "price": 9,
            "molihua": 602167,
            "zhengshanxiaozhong": 448444,
            "dahongpao": 575911
          }, {"price": 10, "molihua": 611276, "zhengshanxiaozhong": 472072.6, "dahongpao": 605973.7}, {
            "price": 11,
            "molihua": 620385,
            "zhengshanxiaozhong": 495701.2,
            "dahongpao": 636036.4
          }, {"price": 12, "molihua": 629494, "zhengshanxiaozhong": 519329.8, "dahongpao": 666099.1}, {
            "price": 13,
            "molihua": 638603,
            "zhengshanxiaozhong": 542958.4,
            "dahongpao": 696161.8
          }, {"price": 14, "molihua": 647712, "zhengshanxiaozhong": 566587, "dahongpao": 726224.5}, {
            "price": 15,
            "molihua": 656821,
            "zhengshanxiaozhong": 590215.6,
            "dahongpao": 756287.2
          }, {"price": 16, "molihua": 665930, "zhengshanxiaozhong": 613844.2, "dahongpao": 786349.9}, {
            "price": 17,
            "molihua": 675039,
            "zhengshanxiaozhong": 637472.8,
            "dahongpao": 816412.6
          }, {"price": 18, "molihua": 684148, "zhengshanxiaozhong": 661101.4, "dahongpao": 846475.3}, {
            "price": 19,
            "molihua": 693257,
            "zhengshanxiaozhong": 684730,
            "dahongpao": 876538
          }, {"price": 20, "molihua": 708749, "zhengshanxiaozhong": 692021.8, "dahongpao": 927274.4}, {
            "price": 21,
            "molihua": 724241,
            "zhengshanxiaozhong": 699313.6,
            "dahongpao": 978010.8
          }, {"price": 22, "molihua": 739733, "zhengshanxiaozhong": 706605.4, "dahongpao": 1028747.2}, {
            "price": 23,
            "molihua": 755225,
            "zhengshanxiaozhong": 713897.2,
            "dahongpao": 1079483.6
          }, {"price": 24, "molihua": 770717, "zhengshanxiaozhong": 721189, "dahongpao": 1130220}, {
            "price": 25,
            "molihua": 865593.6,
            "zhengshanxiaozhong": 763282.8,
            "dahongpao": 1183493.4
          }, {"price": 26, "molihua": 960470.2, "zhengshanxiaozhong": 805376.6, "dahongpao": 1236766.8}, {
            "price": 27,
            "molihua": 1055346.8,
            "zhengshanxiaozhong": 847470.4,
            "dahongpao": 1290040.2
          }, {"price": 28, "molihua": 1150223.4, "zhengshanxiaozhong": 889564.2, "dahongpao": 1343313.6}, {
            "price": 29,
            "molihua": 1245100,
            "zhengshanxiaozhong": 931658,
            "dahongpao": 1396587
          }, {"price": 30, "molihua": 1310455.6, "zhengshanxiaozhong": 983354.8, "dahongpao": 1397779.6}, {
            "price": 31,
            "molihua": 1375811.2,
            "zhengshanxiaozhong": 1035051.6,
            "dahongpao": 1398972.2
          }, {"price": 32, "molihua": 1441166.8, "zhengshanxiaozhong": 1086748.4, "dahongpao": 1400164.8}, {
            "price": 33,
            "molihua": 1506522.4,
            "zhengshanxiaozhong": 1138445.2,
            "dahongpao": 1401357.4
          }, {"price": 34, "molihua": 1571878, "zhengshanxiaozhong": 1190142, "dahongpao": 1402550}, {
            "price": 35,
            "molihua": 1649676.6,
            "zhengshanxiaozhong": 1176697.4,
            "dahongpao": 1320282.2
          }, {"price": 36, "molihua": 1727475.2, "zhengshanxiaozhong": 1163252.8, "dahongpao": 1238014.4}, {
            "price": 37,
            "molihua": 1805273.8,
            "zhengshanxiaozhong": 1149808.2,
            "dahongpao": 1155746.6
          }, {"price": 38, "molihua": 1883072.4, "zhengshanxiaozhong": 1136363.6, "dahongpao": 1073478.8}, {
            "price": 39,
            "molihua": 1960871,
            "zhengshanxiaozhong": 1122919,
            "dahongpao": 991211
          }, {"price": 40, "molihua": 1829708.4, "zhengshanxiaozhong": 1080922.2, "dahongpao": 955610.6}, {
            "price": 41,
            "molihua": 1698545.8,
            "zhengshanxiaozhong": 1038925.4,
            "dahongpao": 920010.2
          }, {"price": 42, "molihua": 1567383.2, "zhengshanxiaozhong": 996928.6, "dahongpao": 884409.8}, {
            "price": 43,
            "molihua": 1436220.6,
            "zhengshanxiaozhong": 954931.8,
            "dahongpao": 848809.4
          }, {"price": 44, "molihua": 1305058, "zhengshanxiaozhong": 912935, "dahongpao": 813209}, {
            "price": 45,
            "molihua": 1189984.4,
            "zhengshanxiaozhong": 838173.4,
            "dahongpao": 742118.2
          }, {"price": 46, "molihua": 1074910.8, "zhengshanxiaozhong": 763411.8, "dahongpao": 671027.4}, {
            "price": 47,
            "molihua": 959837.2,
            "zhengshanxiaozhong": 688650.2,
            "dahongpao": 599936.6
          }, {"price": 48, "molihua": 844763.6, "zhengshanxiaozhong": 613888.6, "dahongpao": 528845.8}, {
            "price": 49,
            "molihua": 729690,
            "zhengshanxiaozhong": 539127,
            "dahongpao": 457755
          }, {"price": 50, "molihua": 637500.2, "zhengshanxiaozhong": 501090, "dahongpao": 424428.6}, {
            "price": 51,
            "molihua": 545310.4,
            "zhengshanxiaozhong": 463053,
            "dahongpao": 391102.2
          }, {"price": 52, "molihua": 453120.6, "zhengshanxiaozhong": 425016, "dahongpao": 357775.8}, {
            "price": 53,
            "molihua": 360930.8,
            "zhengshanxiaozhong": 386979,
            "dahongpao": 324449.4
          }, {"price": 54, "molihua": 268741, "zhengshanxiaozhong": 348942, "dahongpao": 291123}, {
            "price": 55,
            "molihua": 251500.8,
            "zhengshanxiaozhong": 341200.4,
            "dahongpao": 283223.4
          }, {"price": 56, "molihua": 234260.6, "zhengshanxiaozhong": 333458.8, "dahongpao": 275323.8}, {
            "price": 57,
            "molihua": 217020.4,
            "zhengshanxiaozhong": 325717.2,
            "dahongpao": 267424.2
          }, {"price": 58, "molihua": 199780.2, "zhengshanxiaozhong": 317975.6, "dahongpao": 259524.6}, {
            "price": 59,
            "molihua": 182540,
            "zhengshanxiaozhong": 310234,
            "dahongpao": 251625
          }, {"price": 60, "molihua": 175060.5, "zhengshanxiaozhong": 299613.4, "dahongpao": 243134}, {
            "price": 61,
            "molihua": 167581,
            "zhengshanxiaozhong": 288992.8,
            "dahongpao": 234643
          }, {"price": 62, "molihua": 160101.5, "zhengshanxiaozhong": 278372.2, "dahongpao": 226152}, {
            "price": 63,
            "molihua": 152622,
            "zhengshanxiaozhong": 267751.6,
            "dahongpao": 217661
          }, {"price": 64, "molihua": 145142.5, "zhengshanxiaozhong": 257131, "dahongpao": 209170}, {
            "price": 65,
            "molihua": 137663,
            "zhengshanxiaozhong": 246510.4,
            "dahongpao": 200679
          }, {"price": 66, "molihua": 130183.5, "zhengshanxiaozhong": 235889.8, "dahongpao": 192188}, {
            "price": 67,
            "molihua": 122704,
            "zhengshanxiaozhong": 225269.2,
            "dahongpao": 183697
          }, {"price": 68, "molihua": 115224.5, "zhengshanxiaozhong": 214648.6, "dahongpao": 175206}, {
            "price": 69,
            "molihua": 107745,
            "zhengshanxiaozhong": 204028,
            "dahongpao": 166715
          }, {"price": 70, "molihua": 105263.7, "zhengshanxiaozhong": 200730.5, "dahongpao": 164026.1}, {
            "price": 71,
            "molihua": 102782.4,
            "zhengshanxiaozhong": 197433,
            "dahongpao": 161337.2
          }, {"price": 72, "molihua": 100301.1, "zhengshanxiaozhong": 194135.5, "dahongpao": 158648.3}, {
            "price": 73,
            "molihua": 97819.8,
            "zhengshanxiaozhong": 190838,
            "dahongpao": 155959.4
          }, {"price": 74, "molihua": 95338.5, "zhengshanxiaozhong": 187540.5, "dahongpao": 153270.5}, {
            "price": 75,
            "molihua": 92857.2,
            "zhengshanxiaozhong": 184243,
            "dahongpao": 150581.6
          }, {"price": 76, "molihua": 90375.9, "zhengshanxiaozhong": 180945.5, "dahongpao": 147892.7}, {
            "price": 77,
            "molihua": 87894.6,
            "zhengshanxiaozhong": 177648,
            "dahongpao": 145203.8
          }, {"price": 78, "molihua": 85413.3, "zhengshanxiaozhong": 174350.5, "dahongpao": 142514.9}, {
            "price": 79,
            "molihua": 82932,
            "zhengshanxiaozhong": 171053,
            "dahongpao": 139826
          }, {"price": 80, "molihua": 81213.9, "zhengshanxiaozhong": 167826, "dahongpao": 137137.7}, {
            "price": 81,
            "molihua": 79495.8,
            "zhengshanxiaozhong": 164599,
            "dahongpao": 134449.4
          }, {"price": 82, "molihua": 77777.7, "zhengshanxiaozhong": 161372, "dahongpao": 131761.1}, {
            "price": 83,
            "molihua": 76059.6,
            "zhengshanxiaozhong": 158145,
            "dahongpao": 129072.8
          }, {"price": 84, "molihua": 74341.5, "zhengshanxiaozhong": 154918, "dahongpao": 126384.5}, {
            "price": 85,
            "molihua": 72623.4,
            "zhengshanxiaozhong": 151691,
            "dahongpao": 123696.2
          }, {"price": 86, "molihua": 70905.3, "zhengshanxiaozhong": 148464, "dahongpao": 121007.9}, {
            "price": 87,
            "molihua": 69187.2,
            "zhengshanxiaozhong": 145237,
            "dahongpao": 118319.6
          }, {"price": 88, "molihua": 67469.1, "zhengshanxiaozhong": 142010, "dahongpao": 115631.3}, {
            "price": 89,
            "molihua": 65751,
            "zhengshanxiaozhong": 138783,
            "dahongpao": 112943
          }, {"price": 90, "molihua": 59581, "zhengshanxiaozhong": 125592.7, "dahongpao": 102205}, {
            "price": 91,
            "molihua": 53411,
            "zhengshanxiaozhong": 112402.4,
            "dahongpao": 91467
          }, {"price": 92, "molihua": 47241, "zhengshanxiaozhong": 99212.1, "dahongpao": 80729}, {
            "price": 93,
            "molihua": 41071,
            "zhengshanxiaozhong": 86021.8,
            "dahongpao": 69991
          }, {"price": 94, "molihua": 34901, "zhengshanxiaozhong": 72831.5, "dahongpao": 59253}, {
            "price": 95,
            "molihua": 28731,
            "zhengshanxiaozhong": 59641.2,
            "dahongpao": 48515
          }, {"price": 96, "molihua": 22561, "zhengshanxiaozhong": 46450.9, "dahongpao": 37777}, {
            "price": 97,
            "molihua": 16391,
            "zhengshanxiaozhong": 33260.6,
            "dahongpao": 27039
          }, {"price": 98, "molihua": 10221, "zhengshanxiaozhong": 20070.3, "dahongpao": 16301}, {
            "price": 99,
            "molihua": 4051,
            "zhengshanxiaozhong": 6880,
            "dahongpao": 5563
          }]
        }
      }
    },
    mounted() {
      setTimeout(() => {
        const saveData = localStorage.getItem(this.$route.query.id + '-chartComponent3')
        if (saveData) {
          this.initData = JSON.parse(saveData)
        }
      }, 500)
    },
    created() {
      for (let i = 0; i < 5; i++) {
        this.tableData = this.tableData.concat(this.tableData)
      }
      this.tableFilter = this.tableData.slice((this.pagination.currentPage - 1) * 6, this.pagination.currentPage * 6)
      this.pagination.total = this.tableData.length
    },
    methods: {
      finish() {
        if (this.initData.zongjie.trim() === '') {
          this.$message.error('总结分析报告不能为空！');
        }
        this.initData.resolve = true
        let $id = this.$route.query.id
        let obj = this.initData
        localStorage.setItem($id + '-chartComponent3', JSON.stringify(obj))
        this.$message({
          message: '保存成功，已完成任务',
          type: 'success'
        });
        this.$emit('finish')
      },
      changePage(currentPage) {
        this.pagination.currentPage = currentPage
        this.tableFilter = this.tableData.slice((this.pagination.currentPage - 1) * 6, this.pagination.currentPage * 6)
      },
      generateTable(cardData) {
        let obj = {
          '茶产品': cardData.name,
          '茶产品SKU': cardData.sku
        }
        let $range = cardData.range.split(',')
        $range.forEach((item) => {
          let sliceStart = item.split('-')[0]
          let sliceEnd = item.split('-')[1]
          let sales = 0
          let $originData = this.originData.total.slice(sliceStart, sliceEnd)
          $originData.forEach((x) => {
            sales = 0
            if (cardData.sku === 'TEA514521548' && (cardData.name === '茉莉花' || cardData.name === '茉莉花茶')) {
              sales = x['molihua']
            }
            if (cardData.sku === 'TEA474528754' && cardData.name === '正山小种') {
              sales = x['zhengshanxiaozhong']
            }
            if (cardData.sku === 'TEA784584123' && cardData.name === '大红袍') {
              sales = x['dahongpao']
            }
          })
          obj[item] = sales
        })
        cardData.items = [obj]
      }
    }
  }
</script>

<style scoped lang="scss">
  .big-chart {
    width: 92vw;
    height: 800px;
    position: fixed;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    transition: all 0.3s ease-in;
    
    &.left {
      left: 4vw;
      bottom: 26px;
      transform: translateX(-110%);
      
      .person-image {
        left: 0;
        bottom: 0;
      }
      
      .people-talk {
        left: 10px;
        bottom: 300px;
        -webkit-clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 29% 83%, 35% 100%, 15% 83%, 0 83%);
        clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 29% 83%, 35% 100%, 15% 83%, 0 83%);
      }
      
      .big-chart-main {
        padding: 30px 30px 30px 460px;
        box-shadow: 23px 0 20px 10px #63759d;
      }
    }
    
    &.right {
      right: 4vw;
      bottom: 26px;
      transform: translateX(110%);
      
      .person-image {
        right: 0;
        bottom: 0;
      }
      
      .people-talk {
        right: 10px;
        bottom: 400px;
        -webkit-clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 29% 83%, 35% 100%, 15% 83%, 0 83%);
        clip-path: polygon(0% 0%, 100% 0%, 100% 83%, 29% 83%, 35% 100%, 15% 83%, 0 83%);
      }
      
      .big-chart-main {
        padding: 30px 460px 30px 30px;
        box-shadow: -23px 0 20px 10px #63759d;
      }
    }
    
    &.left.show {
      transform: translateX(0);
      transition: all 0.3s ease-in;
    }
    
    &.right.show {
      transform: translateX(0);
      transition: all 0.3s ease-in;
    }
    
    .btn {
      cursor: pointer;
      border: 2px solid #8495b1;
      width: 80px;
      height: 40px;
      text-align: center;
      border-radius: 8px;
      box-shadow: 10px 10px 10px #8495b1;
      background: #ffffff;
      margin-left: 10px;
    }
    
    .person-image {
      position: absolute;
      width: 384px;
      z-index: 99;
      filter: drop-shadow(16px 18px 10px #155e9e);
    }
    
    .people-talk {
      position: absolute;
      z-index: 99;
      width: 400px;
      background: #fa5130;
      padding: 16px 16px 28px 16px;
      color: #FFFFFF;
      font-family: fangsong, serif;
      animation: talkMove 1s ease-in-out both;
      
      p {
        font-size: 18px;
        font-weight: bolder;
        line-height: 20px;
      }
      
      .next-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        
        > i {
          font-size: 20px;
          font-weight: bolder;
          padding: 6px;
          cursor: pointer;
        }
      }
      
      .go-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 10px;
        
        span {
          cursor: pointer;
          background: #FFFFFF;
          padding: 6px;
          color: #ff5722;
          border-radius: 6px;
          font-weight: bolder;
          font-size: 18px;
          box-shadow: 0px 0px 10px #ffffff;
        }
      }
    }
    
    .big-chart-main {
      flex-grow: 1;
      flex-shrink: 1;
      border-radius: 10px;
      z-index: 98;
      font-size: 16px;
      backdrop-filter: blur(26px);
      background: transparent;
      
      .close {
        border: 2px solid #8495b1;
        width: 80px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 20px;
        font-weight: bolder;
        border-radius: 8px;
        background: #ffffff;
        cursor: pointer;
        position: absolute;
        right: 10px;
        top: 10px;
        
        i {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 26px;
          color: #5c6d92;
        }
      }
      
      p {
        width: 700px;
        padding: 10px;
        line-height: 22px;
        border: 2px solid #8495b1;
        box-shadow: 10px 10px 10px #8495b1;
        border-radius: 10px;
        margin-bottom: 10px;
        background: #FFFFFF;
        
        span {
          font-size: 18px;
          font-weight: bolder;
          color: red;
        }
      }
      
      .big-chart-main-footer {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      
      .big-chart-main-view {
        height: 740px;
        overflow-y: auto;
        
        .title {
          font-size: 24px;
          font-weight: bolder;
          text-align: center;
          margin-bottom: 10px;
        }
        
        .table-wrap {
          padding: 10px;
          margin-bottom: 20px;
        }
        
        .echart-wrap {
          padding: 0 10px 0 10px;
          
          .generate-table-wrap {
            .g-t-w-view {
              background: #FFFFFF;
              
              .g-t-w-v-row {
                &:nth-child(0) {
                  .label {
                    width: 140px;
                  }
                }
                
                &:nth-child(1) {
                  .label {
                    width: 140px;
                  }
                }
                
                text-align: center;
                
                .label {
                  padding: 16px;
                  border-bottom: 1px solid #cacaca;
                  border-right: 1px solid #cacaca;
                }
                
                .value {
                  border-right: 1px solid #cacaca;
                  padding: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
  
  @keyframes rightToleft {
    0% {
      opacity: 1;
      transform: translate(10%, -50%);
    }
    
    99% {
      transform: translate(-100%, -50%);
    }
    100% {
      opacity: 0;
    }
  }
  
  @keyframes talkMove {
    0% {
      opacity: 0;
    }
    100% {
      bottom: 438px;
      opacity: 1;
    }
  }
</style>
